import { Box } from "@mui/system";
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import AutoComplete from "../AutoComplete/AutoComplete";
import TextField from "@mui/material/TextField";
import DateComponent from "../DateComponent/DateComponent";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import CheckBoxComponent from "../CheckBox/CheckBoxComponent";
import SelectMainComponent from "../SelectComponent/SelectMainComponent";
import * as XLSX from "xlsx";
import * as MUIICon from "@mui/icons-material";
import { vsprintf } from "sprintf-js";
import CloseIcon from "@mui/icons-material/Close";

import MoveDownIcon from "@mui/icons-material/MoveDown";
import Button from "@mui/material/Button";
import {
  Autocomplete,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  MenuItem,
  Paper,
  Popover,
  Select,
  Typography
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import axios from "axios";
import { baseURL } from "../../api";
import dayjs from "dayjs";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import { useLocation } from "react-router-dom";
import DynamicForm1 from "./DefaultTable";
import InputTableDefaultAllComponent from "./InputTableDefaultAllComponent";
import InputTableDefault from "./InputTableDefault";
import { Global_Data } from "../../globalData/GlobalData";
import NUMBER from "../../component/NUMBER/NUMBER";
import { Icon } from "../../utils/MuiIcons/Icon";
import { serverAddress } from "../../config";
import TranserDialog from "./Transfer/TransferDialog";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import Switch from "@mui/material/Switch";
import SelectAllTransferList from "./Transfer/TransferList";
import DebitCredit from "./DebitCredit";
import { globalvalidateTextField, validateTextField } from "../../utils/validations/Validation";
import VARNUMBER from "../../component/VARNUMBER/VARNUMBER";
import Spinner from "../../component/spinner/Spinner";
import ComponentLoadingBoundary from "../../component/Loading/ComponentLoadingBoundary";
import VarValue from "../../component/Accordian/VarValue";
import RenderSwitchComponent from "../../component/Switch/SWITCH";
import { isFreeFormColumnVisible } from "./freeFormColumnVisibility";
import {
  applySelectionMapping,
  resolveSelectionDataSource
} from "./freeFormSelectionHydration";
import FixedDecimalTextField from "../../component/InputTableDefault/components/FixedDecimalTextField";
import {
  applyFormToFreeFormRows,
  ruleDependencyKey
} from "../../utils/formRules/formRules";

  

  const QuantityCell = ({
    item,
    params,
    freeForm,
    setFreeformdata,
    freeFormTabbleEditArrays,
    mainFormData,
    allFeildForDoucmentSelect,
    token,
    isDisabledTable,
    serverAddress,
    handlePointChange1,
    getErrorDetails,
    freeFormError,
    handleFocus,
    handleSelectionBlur,
    handleSelectionChange,
    handleNumerChange,
    replaceSInventoryCode,
    replacePlaceholders
  }) => {
    const [selectedValue, setSelectedValue] = useState("");
    const [quantitySelectOptions, setQuantitySelectOptions] = useState([]);

    const val = useMemo(() => {
      if (freeForm?.[params.row.id - 1]?.[item?.component?.sName] !== "") {
        return handlePointChange1(
          freeForm[params.row.id - 1]?.[item?.component?.sName]?.toString(),
          item?.component?.iDecimalPlaces
        );
      }
      return "";
    }, [freeForm, params.row.id, item]);

    const qtyIndex = quantitySelectOptions.findIndex(
      qty => qty.id == params.row.id
    );

    const handleChange = e => {
      const selected = e.target.value;
      setSelectedValue(selected);

      const selectedOption = quantitySelectOptions[qtyIndex]?.data?.find(
        option => option?.[item?.data?.sValueField] == selected
      );

      const conversion = selectedOption?.sConversion;
      const conversionField = item?.component?.sConversionName;

      setFreeformdata(prev =>
        prev.map(row =>
          row.id == params.row.id && conversionField
            ? {
                ...row,
                [conversionField]: `${selected}:${Number(conversion || 0).toFixed(2)}`
              }
            : row
        )
      );
    };

    useEffect(() => {
      const fetchData = async () => {
        const uri =
          serverAddress +
          replaceSInventoryCode(
            item?.data?.sDataSource,
            params.row,
            allFeildForDoucmentSelect
          );

        const inventoryCodeMatch = uri.match(/inventorycode=([^&]*)/);
        const inventoryCode = inventoryCodeMatch
          ? decodeURIComponent(inventoryCodeMatch[1]).replace(/'/g, "")
          : null;

        if (!inventoryCode) return;

        const response = await axios.get(uri, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        setQuantitySelectOptions([
          {
            id: params.row.id,
            data: response?.data?.data?.records || []
          }
        ]);
      };

      fetchData();
    }, [
      params.row.id,
      JSON.stringify(params.row),
      item?.data?.sDataSource
    ]);

    useEffect(() => {
      if (!quantitySelectOptions.length || selectedValue) return;

      const options = quantitySelectOptions[qtyIndex]?.data || [];
      if (!options.length) return;

      let defaultValue = options[0]?.[item?.data?.sValueField];

      if (mainFormData?.form?.sFormAction === "EDIT") {
        const editRow = freeFormTabbleEditArrays?.[0]?.tabledetails?.find(
          row => row.id == params.row.id
        );

        const editConversionCode =
          editRow?.[item?.component?.sConversionName]?.split(":")?.[0];

        defaultValue =
          options.find(
            qty => qty[item?.data?.sValueField] == editConversionCode
          )?.[item?.data?.sValueField] || defaultValue;
      }

      if (defaultValue) {
        handleChange({
          target: {
            name: item?.component?.sName,
            value: defaultValue
          }
        });
      }
    }, [quantitySelectOptions, selectedValue]);

    return (
      <>
        <div
          style={{ width: "100%" }}
          id={`${item?.component?.sName}-${item.inputtable.sColumnID}-${params.row.id}`}
        >
          <TextField
            id={`${item?.component?.sName}-${params.row.id}`}
            name={item?.component?.sName}
            inputProps={{ style: { textAlign: item?.component?.sJustify } }}
            onChange={e => handleNumerChange(e, params.row.id)}
            disabled={
              isDisabledTable == false
                ? !(item?.inputtable?.bEditable == 1 || item?.inputtable?.bEditable == 3)
                : isDisabledTable
            }
            value={
              freeForm[params.row.id - 1]?.[item?.component?.sName] == ""
                ? freeForm[params.row.id - 1]?.[item?.component?.sName]
                : val
            }
            {...item?.component?.sProps}
            {...item?.component?.options?.others1}
            onKeyDown={handleFocus}
            onFocus={handleFocus}
            onBlur={handleSelectionBlur}
            onSelect={handleSelectionChange}
            error={getErrorDetails(freeFormError, params.row.id)[item?.component?.sName]}
            placeholder={
              getErrorDetails(freeFormError, params.row.id)[item?.component?.sName]
                ? getErrorDetails(freeFormError, params.row.id)[item?.component?.sName]
                : item?.component?.sPlaceHolder
            }
            helperText={
              getErrorDetails(freeFormError, params.row.id)[item?.component?.sName] ||
              item?.component?.sHelper
            }
            label={item?.component?.sLabel}
          />
        </div>

        <FormControl fullWidth>
          <InputLabel id={`${item?.component?.sName}-label-${params.row.id}`}>
            Select Option
          </InputLabel>

          <Select
            id={`${item?.component?.sName}-type-${params.row.id}`}
            value={String(selectedValue || "")}
            labelId={`${item?.component?.sName}-label-${params.row.id}`}
            name={item?.component?.sName}
            label="Select Option"
            onChange={handleChange}
            {...item?.component?.sProps}
          >
            {quantitySelectOptions[qtyIndex]?.data?.map(qty => (
              <MenuItem
                value={String(qty[item?.data?.sValueField])}
                key={qty[item?.data?.sValueField]}
              >
                <div
                  component="span"
                  style={{ width: "100%" }}
                  dangerouslySetInnerHTML={{
                    __html:
                      qty && qty != "" && Object.keys(qty).length !== 0
                        ? vsprintf(
                            item?.data?.sDisplayFormat,
                            replacePlaceholders(item?.data?.sDisplayField, qty)
                              ?.replace(/[{}]/g, "")
                              ?.split(",")
                          )
                        : ""
                  }}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    );
  };

const TableComponent = ({
  format,
  data,
  freeFormTabbleEditArrays,
  setdifferenceDebitCredit,
  tablefreeformfield,
  freeFormTabbleArrays,
  setFreeFormTabbleArrays,
  setfreeFormValidateFunction,
  setmultirecordValidateFunction,
  setdefaultTableValidateFunction,
  setdebitCreditValidateFunction,
  setSelectAndAutocompleteSname,
  company,
  textValue,
  setdebitCreditTableData,
  isSubmited,
  tabledata,
  tablesummaryfields,
  freeformTableMode,
  freeformTableName,
  setFreeFromTotals,
  formAction,
  isDisabledTable,
  formdata,
  formData,
  documentSelectTableData,
  documentSelectmappingData,
  handleClickOpen2,
  uniqueErrors,
  setUniqueErrors,
  setdefaultTableNameAndModel, //rfg UAT
  eventSelectTableData,
  eventSelectTableMapping
}) => {

  const [subtotal1, setsubTotal1] = useState(parseFloat(0).toFixed(2));
  const [grand_total, setGrandtotal] = useState(parseFloat(0).toFixed(2));
  const [subTotal, setSubTotal] = useState({});
  const [subTotalDef, setSubTotalDef] = useState(null);
  const [selectTax, setSelectTax] = useState();
  const [totalHandle, settotalHandle] = useState(parseFloat(0).toFixed(2));
  const [totalShipping, settotalShipping] = useState(parseFloat(0).toFixed(2));
  const [totaldiscount, settotaldiscount] = useState(parseFloat(0).toFixed(2));
  const [totalTax, setTotalTax] = useState(parseFloat(0).toFixed(2));
  const [totaladjustment, settotaladjustment] = useState(parseFloat(0).toFixed(2));

  let urlCapture = window.location.pathname + window.location.search;

  const [taxOption, setTaxOptions] = useState([]);
  const [allfeildsNames, setAllfeildsNames] = useState({});
  const [allfeildsNames1, setAllfeildsNames1] = useState({});
  const [allFeildForDoucmentSelect, setallFeildForDoucmentSelect] = useState({});
  const [allfeildsWithsType, setAllfeildsWithsType] = useState({});
  const [handlettotal, sethandletotal] = useState({});
  const [feildsWithColumns, setfeildsWithColumns] = useState({});
  const [totalDebit, setTotalDebit] = useState();
  const [totalCredit, setTotalCredit] = useState();
  const [price, setPrice] = useState();
  const [taxFirstOption, setTaxFirstOption] = useState("");
  const [fixedColumnFeilds, setfixedColumnFeilds] = useState({});
  const [fixedColumnFeildsName, setfixedColumnFeildsName] = useState({});

  const {
    token,
    freeFormInitState,
    setFreeFormInitState,
    mainFormData,
    setmainFormData,
    freeFromtableRowDataStore,
    globalReloadTriggred,
    freeFormToDefault,
    setFreeFormDataSubmit,
    setFreeFromTableRowDataStore,setOpenDocumentSelect,multiDocumentSelectDataForTable,setmultiDocumentSelectDataForTable,
    setConversionNamesMapping,
    conversionNamesMapping,
    globalFreeFormAutoValueData, submitPayloadLoading
  } = Global_Data();
  // =================================
  const [summ_handling, setSumm_handling] = useState(parseFloat(0).toFixed(2));
  const [summ_shipping, setSumm_shipping] = useState(parseFloat(0).toFixed(2));
  const [summ_discount, setSumm_discount] = useState(parseFloat(0).toFixed(2));
  const [summ_adjustment, setSumm_adjustment] = useState(parseFloat(0).toFixed(2));
  const [summ_grandTotal, setSumm_grandTotal] = useState(parseFloat(0).toFixed(2));

  // =================================
  // default data
  const [rows, setRows] = useState([]); //rfg UAT
  const [freeForm, setFreeformdata] = useState([]);
  const [freeFormError, setfreeFormError] = useState([]);
  const [freeFormValidation, setfreeFormValidation] = useState({});

  const formToRowRules = useMemo(
    () =>
      (data?.data?.rules || []).filter(
        rule => String(rule?.sType || "").toUpperCase() === "SYNC_FORM_TO_ROW"
      ),
    [data?.data?.rules]
  );
  const formToRowDependencyKey = ruleDependencyKey(formToRowRules, textValue);

  const lastTableFreeFormFieldRef = React.useRef();
  
  // end default
  const [emptyrows, setEmptyRow] = useState([]);
  const [emptyfreeform, setEmptyFreeform] = useState([]);
  const loacation = useLocation();
  const path = loacation?.search?.toLocaleLowerCase();
  // console.log(selectTax,'selectTax');
  function getErrorDetails(data, Id) {
    const rtnData = data.filter(elm => elm?.id == Id);
    if (rtnData?.length > 0) {
      return rtnData[0];
    } else {
      return false;
    }
  }

  

  useEffect(() => {
      const quantityMap = {};

      data?.child?.forEach(field => {
        if (
          field?.component?.sType === "QUANTITY" &&
          field?.component?.sName &&
          field?.component?.sConversionName
        ) {
          quantityMap[field.component.sName] = field.component.sConversionName;
        }
      });

      if (Object.keys(quantityMap).length === 0) return;

      setConversionNamesMapping(prev => {
        const next = { ...prev, ...quantityMap };
        return JSON.stringify(prev || {}) === JSON.stringify(next || {})
          ? prev
          : next;
      });
    }, [data?.child, setConversionNamesMapping]);

  useEffect(() => {
    const mapping = data?.component?.bulkLoad?.sMapping;

    if (!freeForm?.length || !mapping || !Object.keys(mapping).length) {
      return;
    }

    const nextFreeForm = freeForm.map(row => {
      const nextRow = { ...row };
      let rowChanged = false;

      for (const [, value] of Object.entries(mapping)) {
        const fieldName = allfeildsNames[value];
        const currentValue = nextRow[fieldName];

        if (typeof currentValue === "number" && !isNaN(currentValue)) {
          const formattedValue = currentValue.toFixed(2);

          if (nextRow[fieldName] !== formattedValue) {
            nextRow[fieldName] = formattedValue;
            rowChanged = true;
          }
        }
      }

      return rowChanged ? nextRow : row;
    });

    const isSame =
      JSON.stringify(freeForm || []) === JSON.stringify(nextFreeForm || []);

    if (!isSame) {
      setFreeformdata(nextFreeForm);
    }
  }, [freeForm, data?.component?.bulkLoad?.sMapping, allfeildsNames]);

  // useEffect(() => {  //rfg UAT
  //   setdefaultTableNameAndModel(data.component);
  // }, [data]);

  useEffect(() => {
    if(mainFormData?.form?.sFormAction != "EDIT" && globalReloadTriggred){
      setFreeformdata((emptyfreeform || []).map(row => ({ ...row })));
      setfreeFormError([]);
      setUniqueErrors([]);
      setFreeFromTableRowDataStore(prev =>
        (prev || []).filter(elm => elm?.tableName != data?.component?.sName)
      );
    }
  }, [globalReloadTriggred])

  useEffect(() => {
    if (freeFromtableRowDataStore?.length > 0 && freeFormToDefault) {
      setTimeout(() => {
        const updatedStore = freeFromtableRowDataStore.filter(
          elm => elm?.tableName == data?.component?.sName
        );
        if (updatedStore?.length > 0 && !globalReloadTriggred) {
          setFreeformdata(updatedStore?.[0]?.tabledata);
        }
      }, 150);
    }
  }, []);

  useEffect(() => {
    setFreeFromTableRowDataStore(prev => {
      const updatedStore = (prev || []).filter(
        elm => elm?.tableName != data?.component?.sName
      );

      if (!freeForm?.length || globalReloadTriggred) {
        return updatedStore;
      }

      return [
        ...updatedStore,
        { tableName: data?.component?.sName, tabledata: freeForm }
      ];
    });
  }, [freeForm, globalReloadTriggred, data?.component?.sName]);

  useEffect(() => {
    const nextHandleTotal = {
      summ_handleTotal: totalHandle,
      summ_shipTotal: totalShipping,
      summ_discountTotal: totaldiscount,
      summ_adjustmentTotal: totaladjustment,
      summ_taxTotal: totalTax,
      disc_type: subTotal.disc_type
    };

    sethandletotal(prev =>
      JSON.stringify(prev || {}) === JSON.stringify(nextHandleTotal || {})
        ? prev
        : nextHandleTotal
    );
  }, [totalHandle, totalShipping, totaldiscount, totaladjustment, totalTax, subTotal.disc_type]);

  useEffect(() => {
    setSubTotal(prevSubTotal => {
      const nextSubTotal = {
        ...prevSubTotal,
        handlettotal
      };

      return JSON.stringify(prevSubTotal || {}) === JSON.stringify(nextSubTotal || {})
        ? prevSubTotal
        : nextSubTotal;
    });
  }, [handlettotal]);

  function getMatchingKeys(realFeilds, arry) {
    return Array.isArray(arry) && arry?.map(item => {
      // Create a new object to store only the matching keys
      let matchedFields = {};

      // Loop through realFeilds keys and copy the fields from item that exist in realFeilds
      Object.keys(realFeilds).forEach(key => {
        if (key in item) {
          matchedFields[key] = item[key];
        }
      });

      return matchedFields;
    });
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        if(formdata?.form?.sFormSource){
          setLoading(true);
          const response = await axios.get(`${baseURL}${formdata?.form?.sFormSource}`, {
            headers: {
              Authorization: `Bearer ${token}`
              // Other headers if needed
            }
          });
          if (response?.data?.metadata?.status === "OK") {
            const { tabledetails: data = [], tablesummary: datahandling = [] } =
              response?.data?.data[1]?.tablerecords[0] || {};
            const { tabledetails: dataFreeForm = [] } =
              response?.data?.data[1]?.tablerecords[1] || {};
  
            const finaldata = data?.map((item, index) => ({ ...item, id: index + 1 }));
            const finaldata1 = dataFreeForm?.map((item, index) => ({ ...item, id: index + 1 }));
  
            if (formAction === "EDIT") {
              setRows(finaldata);
              setFreeformdata(finaldata1);
  
              const initialValues = {};
              for (const { sSummaryID, sInputValue } of datahandling) {
                initialValues[sSummaryID] = sInputValue;
              }
              setSubTotal(initialValues);
              setSubTotalDef(initialValues);
            }
          }
        }
      } catch (error) {
        // Handle error
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [formAction, formdata?.form?.sFormSource, baseURL]);

  function removeVarTextFields(data, fieldTypes) {
    // Create a deep copy of the data array
    const newData = JSON.parse(JSON.stringify(data));

    // Iterate over each object in the new data array
    for (let i = 0; i < newData.length; i++) {
      const obj = newData[i];
      // Iterate over each key in the object
      for (const key in obj) {
        // Check if the key has VARTEXT type according to fieldTypes
        // if (fieldTypes[key] === "VARTEXT") {
        // If the key has VARTEXT type, remove it from the object
        // delete obj[key];
        // }
      }
    }
    return newData;
  }
  function replaceKeys2(data1, data2) {
    return data2.map(obj => {
      const newObj = {};
      for (let key in obj) {
        if (data1[key]) {
          newObj[data1[key]] = obj[key];
        } else {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    });
  }

  function getUniqueStatus(inputValue) {
    if(inputValue == 2 || inputValue == 3) {
      return "true";
    } else {
      return "false";
    }
  }

function findComponentByName(fields = [], sName) {
  for (const field of fields || []) {
    if (field?.component?.sName === sName) {
      return field;
    }

    const childResult = findComponentByName(field?.child, sName);
    if (childResult) {
      return childResult;
    }
  }

  return null;
}

function getFieldName(value = "") {
  return String(value || "").replace(/[{}]/g, "");
}

function isComponentPhysicallyVisible(componentName) {
  if (!componentName) return true;

  const element =
    document.getElementById(componentName) ||
    document.querySelector(`[id^="${componentName}-"]`) ||
    document.querySelector(`[id^="${componentName}"]`);

  if (!element) return false;

  let current = element;

  while (current && current !== document.body) {
    const style = window.getComputedStyle(current);

    if (
      style.display === "none" ||
      style.visibility === "hidden" ||
      style.opacity === "0"
    ) {
      return false;
    }

    current = current.parentElement;
  }

  const rect = element.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

  useEffect(() => {

    if (Array.isArray(rows) && rows.length > 0 && rows[0] && Object.values(rows[0]).length > 1) {
      tabledata(rows);
    }

    if (Object.values(subTotal)?.length >= 2) {
      tablesummaryfields(subTotal);
    }

    if (freeForm?.length && Object.values(freeForm[0])?.length > 1) {
      const quantityFields = data?.child?.filter(
      field => field?.component?.sType === "QUANTITY"
    );

quantityFields?.forEach(field => {
});
      const resetComponentName = getFieldName(
        data?.component?.resetTable?.sResetOnInvisible
      );

      const shouldResetTable =
        resetComponentName && !isComponentPhysicallyVisible(resetComponentName);

      const freeFormData = {
        sInputTableMode: data?.component?.options?.mode,
        sInputTableName: data?.component?.sName,
        columnFieldNames: Object.values(allfeildsNames1).filter(Boolean),
        tabledetails: shouldResetTable
        ? []
        : removeVarTextFields(
            replaceKeysSendData(freeForm, fixedColumnFeildsName),
            allfeildsWithsType
          )
      };

      setFreeFormTabbleArrays(prev => {
        const existingIndex = prev.findIndex(
          item => item.sInputTableName === freeFormData.sInputTableName
        );

        const next =
          existingIndex !== -1
            ? prev.map((item, index) =>
                index === existingIndex ? structuredClone(freeFormData) : item
              )
            : [...prev, structuredClone(freeFormData)];

        return JSON.stringify(prev || []) === JSON.stringify(next || [])
          ? prev
          : next;
      });

      const uniqueFieldConfig = getUniqueFieldConfig();
      const uniqueFieldName = uniqueFieldConfig?.component?.sName;

      if (uniqueFieldName) {
        const countMap = freeForm.reduce((acc, row) => {
          const value = row?.[uniqueFieldName];

          if (value) {
            acc[value] = (acc[value] || 0) + 1;
          }

          return acc;
        }, {});

        const duplicateIds = freeForm
          .filter(row => row?.[uniqueFieldName] && countMap[row[uniqueFieldName]] > 1)
          .map(row => ({ id: row.id, helperText: "Duplicate Item" }));

        setUniqueErrors(prev =>
          JSON.stringify(prev || []) === JSON.stringify(duplicateIds || [])
            ? prev
            : duplicateIds
        );
      }

      const submitData = shouldResetTable ? [] : freeForm;

      setFreeFormDataSubmit(prev =>
        JSON.stringify(prev) === JSON.stringify({
          table: data?.component?.sName,
          data: submitData
        })
          ? prev
          : {
              table: data?.component?.sName,
              data: submitData
            }
      );

        // const tableFieldData = shouldResetTable ? [] : freeForm;

        // const tableFieldKey = JSON.stringify({
        //   table: data?.component?.sName,
        //   data: tableFieldData
        // });

        // if (lastTableFreeFormFieldRef.current !== tableFieldKey) {
        //   lastTableFreeFormFieldRef.current = tableFieldKey;
        //   tablefreeformfield(tableFieldData);
        // }
    }
  }, [
    rows,
    freeForm,
    subTotal,
    data?.component?.resetTable?.sResetOnInvisible
  ]);

  useEffect(() => {
    if (isSubmited) {
      setRows(emptyrows);
      setFreeformdata(emptyfreeform);
      setSubTotal([]);
      setSelectTax();
      settotalHandle(parseFloat(0).toFixed(2));
      settotalShipping(parseFloat(0).toFixed(2));
      settotaldiscount(parseFloat(0).toFixed(2));
      settotaladjustment(parseFloat(0).toFixed(2));
      setTotalTax(parseFloat(0).toFixed(2));
    }
  }, [isSubmited]);

useEffect(() => {
  const freeclms = { id: 1 };
  const validate = {};
  const allFeild1 = {};
  const allFeild2 = {};
  const AllfeildsWithsType = {};
  const allFeildForDoucmentSelect = {};

  if (data?.component?.options?.mode !== "FREEFORM" || !data?.child) {
    return;
  }

  data.child.forEach(item => {
    const component = item?.component;
    const inputtable = item?.inputtable;

    if (!component?.sName || !inputtable?.sColumnID) {
      return;
    }

    switch (component.sType) {
      case "AUTOCOMPLETE":
      case "TEXTFIELD":
      case "NUMBER":
      case "AMOUNT":
      case "SELECT":
      case "VARNUMBER":
      case "VARTEXT":
      case "QUANTITY":
      case "DATETIME":
      case "SWITCH":
        freeclms[component.sName] = component.sDefaultValue || "";
        break;

      case "CHECKBOX":
        freeclms[component.sName] =
          component.sDefaultValue !== undefined && component.sDefaultValue !== ""
            ? component.sDefaultValue
            : "No";
        break;

      default:
        return;
    }

    validate[component.sName] = item.validation;
    allFeild1[inputtable.sColumnID] = component.sName;
    allFeild2[inputtable.sColumnID] = component.sName;
    allFeildForDoucmentSelect[inputtable.sColumnID] = component.sName;
    AllfeildsWithsType[component.sName] = component.sType;
    allFeild1.header = inputtable.sHeader;
  });

  const fixedColumns = {};
  const feildsWithColumns = {};
  const feildsWithColumnsName = {};

  data?.fixcolumns?.forEach(item => {
    const columnId = item?.sColumnID;
    const component = item?.inputType?.component;

    if (!columnId || !component?.sName) {
      return;
    }

    fixedColumns[columnId] = component.sDefaultValue || "";
    freeclms[columnId] = component.sDefaultValue || "";

    feildsWithColumns[columnId] = component.sName;
    feildsWithColumnsName[component.sName] = columnId;

    validate[columnId] = item?.inputType?.validation;

    allFeild1[columnId] = component.sName;
    allFeild2[columnId] = component.sName;
    AllfeildsWithsType[columnId] = component.sType;
    allFeild1.header = item.sHeader;
  });

  setfeildsWithColumns(feildsWithColumnsName);
  setfixedColumnFeildsName(feildsWithColumns);
  setfixedColumnFeilds(fixedColumns);
  setAllfeildsNames(allFeild1);
  setAllfeildsNames1(allFeild2);
  setallFeildForDoucmentSelect(allFeildForDoucmentSelect);
  setAllfeildsWithsType(AllfeildsWithsType);
  setfreeFormValidation(validate);
  setEmptyFreeform([{ ...freeclms }]);

  const currentRecord = freeFormTabbleArrays?.find(
    item => item?.sInputTableName === data?.component?.sName
  );

  const editRecord = freeFormTabbleEditArrays?.find(
    item => item?.sInputTableName === data?.component?.sName
  );

  if (formAction === "EDIT") {
    if (editRecord?.tabledetails?.length > 0) {
      const editRows = editRecord.tabledetails.map((row, index) => {
        const dataObject = {
          ...freeclms,
          id: index + 1,
          ...row
        };

        data?.child?.forEach(field => {
        if (field?.component?.sType === "QUANTITY") {
          const conversionField = field?.component?.sConversionName;
          const selectField = field?.component?.sSelectName || `${field?.component?.sName}Select`;

          if (conversionField && row?.[conversionField]) {
            dataObject[selectField] = row[conversionField]?.split(":")?.[0] || "";
            dataObject[conversionField] = row[conversionField];
          }
        }
      });

        return dataObject;
      });

      setFreeformdata(getMatchingKeys(freeclms, editRows));
    } else if (freeForm?.length === 0) {
      setFreeformdata([{ ...freeclms }]);
    }

    return;
  }

  if (freeForm?.length === 0) {
      const hasCurrentRecordRows =
        Array.isArray(currentRecord?.tabledetails) &&
        currentRecord.tabledetails.length > 0;

      const existingRow = hasCurrentRecordRows
        ? currentRecord.tabledetails[0]
        : {};

      const nextFreeForm = [
        {
          ...freeclms,
          ...existingRow,
          id: existingRow?.id || 1
        }
      ];

      setFreeformdata(prev =>
        JSON.stringify(prev || []) === JSON.stringify(nextFreeForm || [])
          ? prev
          : nextFreeForm
      );
    }
}, [
  data,
  isSubmited,
  urlCapture,
  taxFirstOption,
  freeFormTabbleEditArrays
]);

useEffect(() => {
  if (
    isSubmited ||
    data?.component?.options?.mode !== "FREEFORM" ||
    formToRowRules.length === 0
  ) {
    return;
  }

  setFreeformdata(currentRows => {
    const nextRows = applyFormToFreeFormRows(
      currentRows || [],
      formToRowRules,
      textValue || {},
      formAction
    );

    return JSON.stringify(currentRows || []) === JSON.stringify(nextRows || [])
      ? currentRows
      : nextRows;
  });
}, [
  data?.component?.options?.mode,
  formAction,
  formToRowDependencyKey,
  formToRowRules,
  isSubmited,
  textValue
]);
  // alert(JSON.stringify(emptyfreeform))

useEffect(() => {
  const editRecord = freeFormTabbleEditArrays?.find(
    item => item?.sInputTableName === data?.component?.sName
  );

  if (!editRecord?.tabledetails?.length) {
    if (formAction === "EDIT") {
      setFreeformdata(emptyfreeform);
    }
    return;
  }

  const filteredComponents = filterComponentsRecursive(mainFormData.details);
  const tableData = getDataByType("INPUTTABLE", filteredComponents);

  const tableRecord = tableData?.find(
    item => item?.sInputTableName === data?.component?.sName
  );

  const baseRow = {
    ...tableRecord?.tabledetails?.[0]
  };

  const newFreeData = heraferidatauseEffect(
    { ...data?.component?.defaultLoad?.sMapping },
    allfeildsNames1,
    editRecord.tabledetails
  );

  const newData = newFreeData.map((row, index) => ({
    ...baseRow,
    ...row,
    id: index + 1
  }));

  if (newData.length > 0) {
    setFreeformdata(replaceKeys2(feildsWithColumns, newData));
  } else {
    setFreeformdata(emptyfreeform);
  }
}, [freeFormTabbleEditArrays, feildsWithColumns, emptyfreeform]);

  function getUniqueFieldConfig() {
  return data?.child?.find(
    field => getUniqueStatus(field?.inputtable?.bEditable) === "true"
  );
}

function getSearchFieldConfig() {
  return data?.child?.find(
    field =>
      field?.component?.sSearchField ||
      field?.inputtable?.sSearchField
  );
}

function buildSearchText(record, fieldConfig) {
  const searchDisplayFields =
    fieldConfig?.component?.sSearchDisplayFields ||
    fieldConfig?.inputtable?.sSearchDisplayFields;

  if (!searchDisplayFields) return "";

  const fields = Array.isArray(searchDisplayFields)
    ? searchDisplayFields
    : searchDisplayFields.split(",").map(field => field.trim());

  return fields
    .map(field => record?.[field] || "")
    .filter(Boolean)
    .join(" ");
}
  const updateAmount = (id, name) => {
    const rowIdx = rows.findIndex(item => item.id === id);
    if (rowIdx === -1) return; // Row not found, do nothing

    const row = rows[rowIdx];

    const qty = +row.col_qty || 1; // parseFloat(row.col_qty || 1);
    const rate = +row.col_rate || 0;
    const disc = +row.col_disc || 0; // parseFloat(row.col_disc || 0);
    const debit = +row.col_debit || 0; // parseFloat(row.col_disc || 0);
    const disctype = row.disc_type || "%"; // parseFloat(row.col_disc || 0);
    const credit = +row.col_credit || 0; // parseFloat(row.col_tax || 0);
    const tax = +row.col_tax || taxFirstOption; // parseFloat(row.col_tax || 0);

    const discDecimal = disc / 100;
    const taxDecimal = tax / 100;
    let amount = 0;

    if (disctype === "%") {
      // amount = (rate*(tax/100)) + qty * rate * (1 - disc / 100);
      amount = qty * rate * (1 - discDecimal) * (1 + taxDecimal);
    } else if (disctype === "Fixed") {
      amount = rate * (tax / 100) + qty * rate - disc;
      // console.log(disc);
    }
    const zero = 0;
    const updatedRow = {
      ...row,
      col_amount: amount.toFixed(2),
      col_qty: qty,
      col_rate: rate.toFixed(2),
      // col_tax: taxFirstOption,
      // disc_type:disctype,
      col_disc: disc.toFixed(2),
      col_debit: name === "col_credit" ? zero.toFixed(2) : debit.toFixed(2),
      col_credit: name === "col_debit" ? zero.toFixed(2) : credit.toFixed(2)
    };

    const updatedRows = [...rows];
    updatedRows[rowIdx] = updatedRow;

    setRows(updatedRows);
  };

  const handleSelectChange = prop => value => {
    if (prop === "summ_tax") {
      let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
      let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
      let summ_adjustment = subTotal?.summ_adjustment ? subTotal?.summ_adjustment : 0;
      let summ_discount = subTotal?.summ_discount ? subTotal?.summ_discount : 0;
      let summ_disc_type = subTotal?.disc_type ? subTotal?.disc_type : 0;

      let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);

      let discountAmount;
      if (summ_disc_type === "%") {
        discountAmount = (total / 100) * summ_discount;
        // discountAmount  = total - discountAmount
      } else {
        discountAmount = summ_discount;
      }

      // const discountAmount =
      // (total / 100) * Number(subTotal?.summ_discount ? subTotal?.summ_discount : 0);

      let new_total = Number(total) - Number(discountAmount) - Number(summ_adjustment);

      const taxAmount = (new_total / 100) * Number(value);

      let total_with_tax = Number(new_total) + Number(taxAmount);

      setSubTotal({
        ...subTotal,
        [prop]: value,
        summ_grandtotal: parseFloat(total_with_tax).toFixed(2)
      });
      // console.log('22222222222');
      setGrandtotal(parseFloat(total_with_tax).toFixed(2));
      setTotalTax(parseFloat(total_with_tax).toFixed(2));
    }
    setSelectTax(value);
  };

  const columns = [];

  columns.push({
    field: "SN",
    headerName: "No.",
    width: 70,
    sortable: true,
    disableColumnMenu: true,
    renderCell: params => {
      const index = params.api.getSortedRowIds().indexOf(params.row.id) + 1;
      return <Typography
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center"
        }}
      >
        {index}
      </Typography>
    }
  });

  const summaryHandler = (prop, value) => event => {
    const value1 = handlePointChange(event.target.value);

    let new_total = 0;
    let update_disc;

    if (prop === "ADD" && value === "summ_handling") {
      if (value1 !== "") {
        new_total = Number(value1) + Number(subtotal1);
        settotalHandle(parseFloat(new_total).toFixed(2));
      }
      if (subTotal?.summ_shipping === "") {
        settotalShipping(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_discount === "") {
        settotaldiscount(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_adjustment === "") {
        settotaladjustment(parseFloat(0).toFixed(2));
      }
      if (value1 === "") {
        settotalHandle(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_shipping !== "") {
        settotalShipping(parseFloat(new_total).toFixed(2));
        new_total = Number(value1) + Number(subtotal1) + Number(subTotal.summ_shipping);
        if (subTotal?.summ_discount !== "" && subTotal?.summ_discount !== undefined) {
          let add_total = Number(value1) + Number(subtotal1) + Number(subTotal.summ_shipping);
          let discount_val = (add_total / 100) * Number(subTotal.summ_discount);
          update_disc = Number(add_total) - discount_val;

          new_total = update_disc;
          settotaldiscount(parseFloat(update_disc).toFixed(2));
        }
        if (subTotal?.summ_adjustment !== "") {
          let add_total = Number(value1) + Number(subtotal1) + Number(subTotal.summ_shipping);

          update_disc = Number(add_total) - subTotal?.summ_adjustment;
          settotaladjustment(parseFloat(update_disc).toFixed(2));
        }
      }
    } else if (prop === "ADD" && value === "summ_shipping") {
      if (subTotal?.summ_adjustment === "" || subTotal?.summ_adjustment === undefined) {
        settotaladjustment(parseFloat(0).toFixed(2));
      }
      if (value1 !== "") {
        new_total = Number(value1) + Number(subtotal1) + Number(subTotal.summ_handling);
        settotalShipping(parseFloat(new_total).toFixed(2));
        if (subTotal?.summ_discount !== "") {
          let add_total = Number(value1) + Number(subtotal1) + Number(subTotal.summ_handling);
          let discount_val = (add_total / 100) * Number(subTotal.summ_discount);
          update_disc = Number(add_total) - discount_val;
          settotaldiscount(parseFloat(update_disc).toFixed(2));
        }
        if (subTotal?.summ_adjustment !== "" && subTotal?.summ_adjustment !== undefined) {
          let add_total = Number(value1) + Number(subtotal1) + Number(subTotal?.summ_handling);
          update_disc = Number(add_total) - Number(subTotal.summ_adjustment);
          settotaladjustment(parseFloat(update_disc).toFixed(2));
        }
      }

      if (subTotal?.summ_handling === "") {
        settotalHandle(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_discount === "") {
        settotaldiscount(parseFloat(0).toFixed(2));
      }

      if (value1 === "") {
        settotalShipping(parseFloat(0).toFixed(2));
      }
    } else if (prop === "SUBTRACT" && value === "summ_discount") {
      if (value1 !== "") {
        let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
        let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
        let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);

        const discountAmount = (total / 100) * Number(value1);

        new_total = Number(total) - discountAmount;

        settotaldiscount(parseFloat(new_total).toFixed(2));

        if (subTotal?.summ_adjustment !== "" && subTotal?.summ_adjustment !== undefined) {
          let add_total = Number(value1) + Number(subtotal1) + Number(subTotal?.summ_handling);
          update_disc = Number(add_total) - Number(subTotal.summ_adjustment);
          settotaladjustment(parseFloat(update_disc).toFixed(2));
        }
      }

      if (subTotal?.summ_handling === "") {
        settotalHandle(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_shipping === "") {
        settotalShipping(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_adjustment === "") {
        settotaladjustment(parseFloat(0).toFixed(2));
      }
      if (value1 === "") {
        settotaldiscount(parseFloat(0).toFixed(2));
      }
    } else if (prop === "MULTIPLY" && value === "summ_discount") {
      if (value1 !== "") {
        let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
        let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
        let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);

        let discountAmount;

        if (subTotal.disc_type === "%") {
          discountAmount = Number(value1) / 100;
          discountAmount = total * discountAmount;
        } else {
          discountAmount = Number(value1);
        }

        new_total = Number(total) - Number(discountAmount);
        settotaldiscount(parseFloat(new_total).toFixed(2));

        // console.log(Number(new_total) , Number(subTotal?.summ_adjustment),'Number(subTotal?.summ_adjustment)');
        if (isNaN(Number(subTotal?.summ_adjustment))) {
          new_total = Number(new_total);
        } else {
          new_total = Number(new_total) - Number(subTotal?.summ_adjustment);
        }

        if (subTotal?.summ_adjustment !== "" && subTotal?.summ_adjustment !== undefined) {
          // let add_total = Number(value1) + Number(subtotal1) + Number(subTotal?.summ_handling);
          update_disc = Number(new_total);
          settotaladjustment(parseFloat(update_disc).toFixed(2));
        }
      }

      if (subTotal?.summ_handling === "") {
        settotalHandle(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_shipping === "") {
        settotalShipping(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_adjustment === "") {
        settotaladjustment(parseFloat(0).toFixed(2));
      }
      if (value1 === "") {
        settotaldiscount(parseFloat(0).toFixed(2));
      }
    } else if (prop === "MULTIPLY" && value === "disc_type") {
      if (value1 === "%") {
        setSubTotal(pre => ({ ...pre, [event.target.name]: value1 }));
        // return console.log(subTotal, 990);
      } else if (value1 === "Fix") {
        setSubTotal(pre => ({ ...pre, [event.target.name]: value1 }));
        // return console.log(subTotal, 990);
      }
      // if (value1 !== "") {
      let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
      let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
      let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);

      let discountAmount;

      if (value1 === "%") {
        discountAmount = Number(subTotal.summ_discount) / 100;
        discountAmount = total * discountAmount;
      } else {
        discountAmount = Number(subTotal.summ_discount);
      }

      new_total = Number(total) - Number(discountAmount);
      settotaldiscount(parseFloat(new_total).toFixed(2));
      // }
      // console.log(subTotal,new_total,'subTotal8');
      // if (subTotal?.summ_handling === "") {
      //   settotalHandle(parseFloat(0).toFixed(2));
      // }
      // if (subTotal?.summ_shipping === "") {
      //   settotalShipping(parseFloat(0).toFixed(2));
      // }
      // if (subTotal?.summ_adjustment === "") {
      //   settotaladjustment(parseFloat(0).toFixed(2));
      // }
      // if (value1 === "") {
      //   settotaldiscount(parseFloat(0).toFixed(2));
      // }
      if (subTotal?.summ_adjustment !== "" && subTotal?.summ_adjustment !== undefined) {
        // let add_total = Number(value1) + Number(subtotal1) + Number(subTotal?.summ_handling);
        update_disc = Number(new_total) - Number(subTotal.summ_adjustment);
        settotaladjustment(parseFloat(update_disc).toFixed(2));
      }
    } else if (prop === "SUBTRACT" && value === "summ_adjustment") {
      if (value1 !== "") {
        let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
        let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
        let summ_discount = subTotal?.summ_discount ? subTotal?.summ_discount : 0;
        let summ_disc_type = subTotal?.disc_type ? subTotal?.disc_type : 0;

        let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);
        let new_discount;
        if (summ_disc_type === "%") {
          new_discount = (total / 100) * summ_discount;
          new_discount = total - new_discount;
        } else {
          new_discount = total - summ_discount;
        }
        new_total = new_discount - Number(value1);

        settotaladjustment(parseFloat(new_total).toFixed(2));
      }
      if (subTotal?.summ_handling === "") {
        settotalHandle(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_shipping === "") {
        settotalShipping(parseFloat(0).toFixed(2));
      }
      if (subTotal?.summ_discount === "") {
        settotaldiscount(parseFloat(0).toFixed(2));
      }
      if (value1 === "") {
        settotaladjustment(parseFloat(0).toFixed(2));
      }
    }

    // Update summ_grandtotal using the latest new_total
    if (value1 === "%" || value1 === "Fix") {
      return setSubTotal({
        ...subTotal,
        [value]: value1,
        summ_grandtotal: parseFloat(new_total).toFixed(2)
      });
    }

    setSubTotal({
      ...subTotal,
      [value]: parseFloat(value1).toFixed(2),
      summ_grandtotal: parseFloat(new_total).toFixed(2)
    });
  };

  const handlePointChange = num => {
    if (!num) {
      return "0.00";
    }
    if (num === "Fix") {
      return "Fix";
    }
    if (num === "%") {
      return "%";
    }

    const inputValue = num?.toString();
    const userInputLength = inputValue?.length;
    let formattedValue;

    if (inputValue.includes(".")) {
      const arr = inputValue.split(".");
      const newInputValue = inputValue?.toString().replace(".", "");
      const lastValue = arr[1];
      const lastValueueLenght = lastValue?.toString().length;

      if (lastValueueLenght === 2) {
        formattedValue = `${arr[0]}.${lastValue}`;
      } else {
        const STRVAL = newInputValue?.toString();
        const arrval = STRVAL.split("");
        const joinVal = arrval.slice(0, -2).join("");

        formattedValue = parseFloat(
          `${parseFloat(joinVal)}.${arrval[arrval.length - 2]}${arrval[arrval.length - 1]}`
        );
      }
    } else {
      if (userInputLength > 2) {
        formattedValue = `${inputValue.slice(0, -2)}.${inputValue.slice(-2)}`;
      } else if (userInputLength === 2) {
        formattedValue = `0.${inputValue}`;
      } else if (userInputLength === 1) {
        formattedValue = `0.0${inputValue}`;
      }
    }
    // console.log(formattedValue,'formattedValue');
    let val = inputValue.includes(".") ? parseFloat(formattedValue) : formattedValue;
    // let val = inputValue.includes(".")
    //     ? parseFloat(formattedValue)
    //     : formattedValue.toFixed(2);

    return isNaN(val) ? "0.00" : val;
  };

  const update = callback => {
    if (callback) {
      callback();
    }
  };

  const takeInput = (e, id, type) => {
    if (type == "setPrice") {
      const list = [...rows];
      const index = list.findIndex(row => row.id === id);
      list[index]["col_rate"] = e;
      setRows(list);
      // setRows({ ...rows, [name]: value });
      updateAmount(id);
      summaryHandler();
    }

    const { name, value } = e.target;

    const feilds = ["col_disc", "col_debit", "col_credit"];
    var newval;

    if (name == "col_debit") {
      newval = handlePointChange(value);
    } else if (name == "col_credit") {
      newval = handlePointChange(value);
    } else if (name == "col_disc") {
      newval = handlePointChange(value);
    } else if (name == "col_rate") {
      newval = handlePointChange(value);
    } else {
      newval = value;
    }
    update();

    const list = [...rows];
    const index = list.findIndex(row => row.id === id);

    list[index][name] = newval;

    setRows(list);
    // setRows({ ...rows, [name]: value });
    updateAmount(id, name);
    summaryHandler();
    // console.log(list,'listlistlist');
  };
  // use this const data in useState

  useEffect(() => {
    const summ_handling = parseFloat(
      Number(subTotal?.summ_handling || 0)
    ).toFixed(2);

    const summ_shipping = parseFloat(
      Number(subTotal?.summ_shipping || 0)
    ).toFixed(2);

    const summ_discount = parseFloat(
      Number(subTotal?.summ_discount || 0)
    ).toFixed(2);

    const summ_adjustment = parseFloat(
      Number(subTotal?.summ_adjustment || 0)
    ).toFixed(2);

    const grandTotalValue =
      Number(subtotal1 || 0) +
      Number(summ_handling || 0) +
      Number(summ_shipping || 0) -
      Number(summ_discount || 0) -
      Number(summ_adjustment || 0);

    const formattedGrandTotal = parseFloat(
      grandTotalValue || 0
    ).toFixed(2);

    setSumm_handling(prev =>
      prev === summ_handling ? prev : summ_handling
    );

    setSumm_shipping(prev =>
      prev === summ_shipping ? prev : summ_shipping
    );

    setSumm_discount(prev =>
      prev === summ_discount ? prev : summ_discount
    );

    setSumm_adjustment(prev =>
      prev === summ_adjustment ? prev : summ_adjustment
    );

    setSumm_grandTotal(prev =>
      prev === formattedGrandTotal
        ? prev
        : formattedGrandTotal
    );

  }, [
    subtotal1,
    subTotal?.summ_handling,
    subTotal?.summ_shipping,
    subTotal?.summ_discount,
    subTotal?.summ_adjustment
  ]);

  useEffect(() => {
    const rowSubtotal = rows.reduce((sum, item) => {
      const amount = Number(item?.col_amount);
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);

    const formattedSubtotal = parseFloat(rowSubtotal || 0).toFixed(2);

    const sumHandle = Number(subTotal?.summ_handling || 0);
    const sumShipping = Number(subTotal?.summ_shipping || 0);
    const summAdjustment = Number(subTotal?.summ_adjustment || 0);

    const grandValue = rowSubtotal + sumHandle + sumShipping - summAdjustment;
    const formattedGrandTotal = parseFloat(grandValue || 0).toFixed(2);

    setGrandtotal(prev =>
      prev === formattedSubtotal ? prev : formattedSubtotal
    );

    setsubTotal1(prev =>
      prev === formattedSubtotal ? prev : formattedSubtotal
    );

    setSubTotal(prev => {
      const next = {
        ...prev,
        summ_subtotal: formattedSubtotal,
        summ_grandtotal: formattedGrandTotal
      };

      return JSON.stringify(prev || {}) === JSON.stringify(next || {})
        ? prev
        : next;
    });
  }, [rows]);

  useEffect(() => {
    setdifferenceDebitCredit(
      (() => {
        const totalAll = +totalDebit - +totalCredit;
        return totalAll.toFixed(2);
      })()
    );
  }, [totalDebit, totalCredit]);

  // useEffect(() => {
  //   if (subTotal) {
  //     let new_total = 0;
  //     let new_total1 = 0;
  //     let update_disc = 0;

  //     if (Object.keys(subTotal).includes("summ_handleTotal")) {
  //       if (subTotal?.summ_handling !== "") {
  //         new_total1 = Number(subTotal?.summ_handling) + Number(subtotal1);
  //         settotalHandle(parseFloat(new_total1).toFixed(2));
  //       }

  //       if (subTotal?.summ_shipping === "") {
  //         settotalShipping(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_discount === "") {
  //         settotaldiscount(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_adjustment === "" || subTotal?.summ_adjustment === undefined) {
  //         settotaladjustment(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_handling === "") {
  //         settotalHandle(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_shipping !== "") {
  //         new_total =
  //           Number(subTotal?.summ_handling) + Number(subtotal1) + Number(subTotal.summ_shipping);
  //         settotalShipping(parseFloat(new_total).toFixed(2));

  //         if (subTotal?.summ_discount !== "") {
  //           let add_total =
  //             Number(subTotal?.summ_handling) + Number(subtotal1) + Number(subTotal.summ_shipping);
  //           let discount_val = (add_total / 100) * Number(subTotal.summ_discount);
  //           update_disc = Number(add_total) - discount_val;
  //           settotaldiscount(parseFloat(update_disc).toFixed(2));
  //         }

  //         if (subTotal?.summ_adjustment !== "" && subTotal?.summ_adjustment !== undefined) {
  //           let add_total =
  //             Number(subTotal?.summ_handling) + Number(subtotal1) + Number(subTotal.summ_shipping);

  //           update_disc = Number(add_total) - Number(subTotal.summ_adjustment);
  //           settotaladjustment(parseFloat(update_disc).toFixed(2));
  //         }
  //       }
  //     } else if (Object.keys(subTotal).includes("summ_shipTotal")) {
  //       if (subTotal?.summ_adjustment === "" || subTotal?.summ_adjustment === undefined) {
  //         settotaladjustment(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_handling !== "") {
  //         new_total =
  //           Number(subTotal?.summ_shipping) + Number(subtotal1) + Number(subTotal.summ_handling);
  //         settotalShipping(parseFloat(new_total).toFixed(2));

  //         if (subTotal?.summ_discount !== "") {
  //           let add_total =
  //             Number(subTotal?.summ_shipping) + Number(subtotal1) + Number(subTotal.summ_handling);
  //           let discount_val = (add_total / 100) * Number(subTotal.summ_discount);
  //           update_disc = Number(add_total) - discount_val;
  //           settotaldiscount(parseFloat(update_disc).toFixed(2));
  //         }

  //         if (subTotal?.summ_handling === "") {
  //           settotalHandle(parseFloat(0).toFixed(2));
  //         }

  //         if (subTotal?.summ_discount === "") {
  //           settotaldiscount(parseFloat(0).toFixed(2));
  //         }

  //         if (subTotal?.summ_shipping === "") {
  //           settotalShipping(parseFloat(0).toFixed(2));
  //         }
  //       }
  //     } else if (Object.keys(subTotal).includes("summ_discountTotal")) {
  //       if (subTotal?.summ_discount !== "") {
  //         let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
  //         let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
  //         let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);

  //         const discountAmount = (total / 100) * Number(subTotal?.summ_discount);

  //         new_total = Number(total) - discountAmount;

  //         settotaldiscount(parseFloat(new_total).toFixed(2));
  //       }

  //       if (subTotal?.summ_handling === "") {
  //         settotalHandle(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_shipping === "") {
  //         settotalShipping(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_adjustment === "") {
  //         settotaladjustment(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_discount === "") {
  //         settotaldiscount(parseFloat(0).toFixed(2));
  //       }
  //     } else if (Object.keys(subTotal).includes("summ_adjustmentTotal")) {
  //       if (subTotal?.summ_adjustment !== "" || subTotal?.summ_adjustment !== undefined) {
  //         let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
  //         let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
  //         let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);
  //         new_total = Number(total) - Number(subTotal?.summ_adjustment);
  //         settotaladjustment(parseFloat(new_total).toFixed(2));
  //       }

  //       if (subTotal?.summ_handling === "") {
  //         settotalHandle(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_shipping === "") {
  //         settotalShipping(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_discount === "") {
  //         settotaldiscount(parseFloat(0).toFixed(2));
  //       }

  //       if (subTotal?.summ_adjustment === "") {
  //         settotaladjustment(parseFloat(0).toFixed(2));
  //       }
  //     }

  //     if (Object.keys(subTotal).includes("sumrm_tax")) {
  //       let sum_handle = subTotal?.summ_handling ? subTotal?.summ_handling : 0;
  //       let sum_shipping = subTotal?.summ_shipping ? subTotal?.summ_shipping : 0;
  //       let total = Number(sum_handle) + Number(subtotal1) + Number(sum_shipping);

  //       const discountAmount =
  //         (total / 100) * Number(subTotal?.summ_discount ? subTotal?.summ_discount : 0);

  //       new_total = Number(total) - Number(discountAmount);

  //       const taxAmount = (new_total / 100) * Number(subTotal?.summ_tax);

  //       let total_with_tax = Number(new_total) + Number(taxAmount);
  //       // console.log();

  //       setGrandtotal(parseFloat(total_with_tax).toFixed(2));
  //     }
  //   }
  // }, [subTotal]);

  function removeCommas(inputString) {
    let result = "";
    for (let i = 0; i < inputString?.length; i++) {
      if (inputString[i] !== ",") {
        result += inputString[i];
      }
    }
    return result;
  }

  const handlePointChange1 = (num1, decimalPlaces = 0) => {
    const num = removeCommas(num1);
    // let val = inputValue.includes(".") ? parseFloat(formattedValue).toFixed(decimalPlaces) : formattedValue;
    let val;
    const inputValue = num?.toString();

    if (inputValue.includes(".")) {
      const arr = inputValue.split(".");
      const lastValue = arr[1];
      const newInputValue = inputValue?.toString().replace(".", "");
      const lastValueueLenght = lastValue?.toString().length;
      const STRVAL = newInputValue?.toString();
      const arrval = STRVAL.split("");
      const newArr = lastValue.split("");

      if (decimalPlaces == 0) {
        val = num;
      }

      if (decimalPlaces == 1) {
        val = lastValue / 10;
        if (arr[0] !== "0") {
          val = `${arr[0]}${lastValue / 10}`;
        }
      }
      if (decimalPlaces == 2) {
        if (lastValueueLenght === 2) {
          val = `${arr[0]}.${lastValue}`;
        } else {
          const joinVal = arrval.slice(0, -2).join("");
          val = `${parseFloat(joinVal)}.${arrval[arrval.length - 2]}${arrval[arrval.length - 1]}`;
        }
      }
      if (decimalPlaces == 3) {
        const joinVal = arrval.slice(0, -3).join("");

        if (newArr.length == 3) {
          val = `${parseFloat(joinVal)}.${newArr[0]}${newArr[1]}${newArr[2]}`;
        } else {
          val = `${parseFloat(joinVal)}.${newArr[1]}${newArr[2]}${newArr[3]}`;
        }
      }
      if (decimalPlaces == 4) {
        const joinVal = arrval.slice(0, -4).join("");
        if (newArr.length == 3) {
          val = `${0}.0${newArr[0]}${newArr[1]}${newArr[2]}`;
        } else {
          val = `${parseFloat(joinVal)}.${newArr[1]}${newArr[2]}${newArr[3]}${newArr[4]}`;
        }
      }

      if (decimalPlaces == 5) {
        const joinVal = arrval.slice(0, -5).join("");
        if (newArr.length == 3) {
          val = `${0}.00${newArr[0]}${newArr[1]}${newArr[2]}`;
        } else {
          val = `${parseFloat(joinVal)}.${newArr[1]}${newArr[2]}${newArr[3]}${newArr[4]}${
            newArr[5]
          }`;
        }
      }
    } else {
      if (decimalPlaces == 0) {
        val = inputValue;
        parseFloat(val).toFixed(decimalPlaces);
      }
      if (decimalPlaces == 1) {
        val = `0.${inputValue}`;
      }
      if (decimalPlaces == 2) {
        if (inputValue.length == 1) {
          // val = `0.0${inputValue}`;
          val = `${inputValue}.00`;
        } else {
          val = `${inputValue}.00`;
        }
      }
      if (decimalPlaces == 3) {
        val = `0.00${inputValue}`;
      }
      if (decimalPlaces == 4) {
        val = `0.000${inputValue}`;
      }
      if (decimalPlaces == 5) {
        val = `0.0000${inputValue}`;
      }
    }

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    }).format(
      isNaN(val) ? (decimalPlaces == "0" ? "0" : `${"0"}${"0".repeat(decimalPlaces)}`) : val
    );
    // return isNaN(val) ? decimalPlaces : val;
  };

  const FreeFormInput = (e, id, type, decimalPlace) => {
    const { name, value } = e.target;
    const value2 =
      type == "number"
        ? Number(String(handlePointChange1(value, decimalPlace)).replace(/,/g, ""))
        : type == "canonical-number"
          ? Number(value)
          : value;

    setFreeformdata(prev =>
      prev.map(row =>
        row.id === id
          ? { ...row, [name]: value2 }
          : row
      )
    );

    const err = validateFreeFormField(value, freeFormValidation[name]);

    setfreeFormError(prev => {
      const exists = prev.some(row => row.id === id);

      if (!exists) {
        return [...prev, { id, [name]: err }];
      }

      return prev.map(row =>
        row.id === id
          ? { ...row, [name]: err }
          : row
      );
    });

  };

  const formcallback = (e, id, name) => {
    if (e) {
      let { value = "" } = e || "";
      const list = [...rows];
      const index = list.findIndex(row => row.id === id);
      list[index][name] = value;
      setRows(list);

      // alert(JSON.stringify(err));
      const err = validateTextField(value, freeFormValidation[name]);
      setfreeFormError(preState => {
        preState[index] = { ...preState[index], [name]: err };
        return preState;
      });
    }
  };

  const FreeFormCallBack = async (e, id, name, itemObj, mapping, fieldConfig) => {
    if (e) {
      const value = e?.target?.value || "";
      const selectedItem = itemObj && typeof itemObj === "object" ? itemObj : {};

      const searchField =
        fieldConfig?.component?.sSearchField ||
        fieldConfig?.inputtable?.sSearchField;

      const searchDisplayFields =
        fieldConfig?.component?.sSearchDisplayFields ||
        fieldConfig?.inputtable?.sSearchDisplayFields;

      const applySelectedItem = row => {
        let updatedRow = { ...row, [name]: value };

        Object.entries(mapping || {}).forEach(([sourceField, targetColumn]) => {
          const targetField = allfeildsNames1[targetColumn] || targetColumn;
          updatedRow[targetField] = selectedItem[sourceField] ?? "";
        });

        if (searchField && searchDisplayFields) {
          const fields = Array.isArray(searchDisplayFields)
            ? searchDisplayFields
            : searchDisplayFields.split(",").map(field => field.trim());

          updatedRow[searchField] = fields
            .map(field => selectedItem[field] || "")
            .filter(Boolean)
            .join(" ");
        }

        return updatedRow;
      };

      const selectedRow = applySelectedItem(
        freeForm.find(row => row.id === id) || { id }
      );
      setFreeformdata(prev =>
        prev.map(row => (row.id === id ? applySelectedItem(row) : row))
      );

      const err = validateTextField(value, freeFormValidation[name]);
      setfreeFormError(prev =>
        prev.map(row =>
          row.id === id
            ? { ...row, [name]: err }
            : row
        )
      );

      const selectionSource = fieldConfig?.data?.sSelectionDataSource;
      const selectionMapping = fieldConfig?.data?.sSelectionMapping;
      if (!value || !selectionSource || !Object.keys(selectionMapping || {}).length) return;

      const resolvedSource = resolveSelectionDataSource(
        selectionSource,
        selectedRow,
        textValue
      );

      // An unresolved dependency means the row is not ready for enrichment yet.
      if (!resolvedSource || /{[^}]+}/.test(resolvedSource)) return;

      try {
        const response = await axios.get(serverAddress + resolvedSource, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const record = response?.data?.data?.records?.[0];
        if (!record) return;

        setFreeformdata(prev =>
          prev.map(row =>
            row.id === id && row[name] === value
              ? applySelectionMapping(
                  row,
                  record,
                  selectionMapping,
                  allfeildsNames1
                )
              : row
          )
        );
      } catch (error) {
        console.error("Unable to hydrate FREEFORM selection data", error);
      }
    }
  };
  const FreeFormCallBackItem = (e, id, name) => {
    if (e) {
      let { value = "" } = e || "";
      const list = [...rows];
      const index = list.findIndex(row => row.id === id);
      list[index][name] = value;
      setRows(list);
      updateAmount(id);
      summaryHandler();
    }
  };

  const handledatachange = (e, id, name, mapfeild) => {
    let index;
    setFreeformdata(prev => {
      const list = [...prev];
      index = list.findIndex(row => row.id === id);
      if (list[index]) {
        list[index][name] = e;
      }
  
      if (mapfeild && Object.keys(mapfeild)?.length > 0) {
        list[index][allFeildForDoucmentSelect[mapfeild.name1]] = mapfeild.value1;
      }
  
      return list;
    });

    if (index !== -1) {
      const err = validateTextField(e, freeFormValidation[name]);
      setfreeFormError(preState => {
        preState[index] = { ...preState[index], [name]: err };
        return preState;
      });
    }
  };

  const handleAddRow = (e, reset = false) => {
    const newRow = {
      id: rows.length + 1,
      disc_type: "%",
      col_qty: "1",
      col_amount: "0.00",
      col_disc: "0.00"
    };
    if (e.target.value) {
      const numNewRows = parseInt(e.target.value);

      const newRows = Array.from({ length: numNewRows }, (_, i) => ({
        id: rows.length + i + 1,
        disc_type: "%"
      }));
      if(reset){
        setRows([...newRows]);
      } else {
        setRows([...rows, ...newRows]);
      }
    } else {
      if(reset){
        setRows([newRow]);
      } else {
        setRows([...rows, newRow]);
      }
    }
  };
  function filterComponentsRecursive(config) {
    const result = {};

    function processField(field) {
      const component = field.component || {};

      const { sType, sName, sDefaultValue } = component;

      if (
        [
          "TEXTFIELD",
          "AUTOCOMPLETE",
          "CHECKBOX",
          "TRANSFERLIST",
          "RADIOGROUP",
          "SELECT",
          "NUMBER",
          // "VARSELECT",
          "IMAGE",
          "DATETIME",
          "INPUT"
        ].includes(sType)
      ) {
        // Check if sType is CHECKBOX and default value is an empty string
        if (sType === "CHECKBOX") {
          result[sName] = sDefaultValue !== "" ? sDefaultValue || "No" : "No";
        } else {
          result[sName] = sDefaultValue || "";
        }
      }

      // Check if the field has a child array
      if (field.child && Array.isArray(field.child)) {
        // Nest child array data under the corresponding sName
        result[sName] = result[sName] || {};
        result[sName].child = {
          sType: sType,
          sInputTableName: sName,
          tabledetails: [filterComponentsRecursive(field.child)]
        };
        // alert(result);
        // Check if component.options.mode is present
        if (component.options) {
          result[sName].child.sInputTableMode = component.options.mode;
        }
      }
      // if (field.fixcolumns && Array.isArray(field.fixcolumns)) {
      //   result[sName] = result[sName] || {};
      //   result[sName].child = {
      //     sType: sType,
      //     sInputTableName: sName,
      //     tabledetails: [filterComponentsRecursive(field.fixcolumns)]
      //   };
      //   // alert(result);
      //   // Check if component.options.mode is present
      //   if (component.options) {
      //     result[sName].child.sInputTableMode = component.options.mode;
      //   }
      // }
    }
    config.forEach(processField);
    return result;
  }
  function getDataByType(sType, dataObject) {
    const result = [];

    function traverse(obj) {
      if (obj && obj.sType === sType) {
        result.push(obj);
      }

      for (const key in obj) {
        if (obj.hasOwnProperty(key) && typeof obj[key] === "object") {
          traverse(obj[key]);
        }
      }
    }

    traverse(dataObject);

    return result;
  }
  const handleAddRow1 = (e, reset = false) => {
    const filteredComponents = filterComponentsRecursive(mainFormData.details);
    const tableData = getDataByType("INPUTTABLE", filteredComponents);

    const existingIndex = tableData?.filter(
      item => item.sInputTableName === data?.component?.sName
    );

    // if (existingIndex[0]?.tabledetails && existingIndex[0]?.tabledetails.length >= 1 ) {

    //   setFreeformdata([{ id: 1,...existingIndex[0]?.tabledetails[0]}]);
    // }
    // delete existingIndex[0]?.tabledetails[0].id
    const newRow = {
      id: freeForm[freeForm.length - 1].id + 1,
      ...existingIndex[0]?.tabledetails[0],
      ...fixedColumnFeilds
    };

    if (e.target.value) {
      const numNewRows = parseInt(e.target.value);
      const newRows = Array.from({ length: numNewRows }, (_, i) => ({
        id: freeForm.length + i + 1,
        ...existingIndex[0]?.tabledetails[0],
        ...fixedColumnFeilds
      }));
      const updData = [...freeForm, ...newRows];
      updData.forEach((item, index) => {
        item.id = index + 1;
      });
      if(reset){
        setFreeformdata(newRows);
      } else {
        setFreeformdata(updData);
      }
    } else {
      const updData = [...freeForm, newRow];
      updData.forEach((item, index) => {
        item.id = index + 1;
      });
      if(reset){
        setFreeformdata([{...newRow, id: 1}]);
      } else {
        setFreeformdata(updData);
      }
    }
    // setFreeformdata([...freeForm, newRow]);
  };

  const handleCloneData = (data, ind) => {
    const arr = [];
    const filterData = data.filter(item => item.id === ind);

    for (let i = 0; i < data.length; i++) {
      if (i === ind - 1) {
        arr.push({ ...filterData[0] });
        arr.push({ ...filterData[0], id: filterData[0].id + 1 });
      } else if (i < ind - 1) {
        arr.push(data[i]);
      } else {
        arr.push({ ...data[i], id: data[i].id + 1 });
      }
    }
    setFreeformdata(arr);
  };
  const handleFocus = event => {
    const { target } = event;
    const { value } = target;
    // Move cursor to the end
    target.setSelectionRange(value.length, value.length);
  };

  const handleKeyDown = event => {
    const { key, target } = event;
    const { selectionStart, value } = target;

    // Disallow moving cursor except for the last digit
    if (
      (key === "ArrowLeft" ||
        key === "ArrowRight" ||
        key === "ArrowUp" ||
        key === "ArrowDown" ||
        key === "Home" ||
        key === "End") &&
      selectionStart !== value.length
    ) {
      event.preventDefault();
    }
  };

  const handleItemClear = (id, field) => {
    const idIndex = freeForm?.findIndex((item) => item.id == id);
    if(idIndex != -1){
      setFreeformdata(prev =>
        prev.map((row, index) =>
          index === idIndex
            ? { ...row, [field]: "" }
            : row
        )
      );
    }
  }

  // this is for child
  data?.component?.options?.mode === "DEFAULT" &&
    data?.child?.forEach(item => {
      columns.push({
        field: item.inputtable.sColumnID,
        headerName: item.inputtable.sHeader,
        width: item.inputtable.iWidth,
        editable: (item?.inputtable?.bEditable == 1 || item?.inputtable?.bEditable == 3) ? true : false,
        // description: item.sDescription,
        sortable: false,
        // valueGetter: item.sValue,
        renderCell: params => {
          if (item?.component.sType === "AUTOCOMPLETE") {
            // console.log(rows[params.row.id - 1],'kkiooaa');

            return (
              <AutoComplete
                textValue1={rows[params.row.id - 1]}
                formcallback={e => formcallback(e, params.row.id, item?.component?.sName)}
                data={item}
                rowsdataFree={
                  rows && rows[params.row.id - 1] && rows[params.row.id - 1][item?.component?.sName]
                }
                Automod={data?.component?.options?.mode}
                formaction={formAction}
                isSubmited={isSubmited}
                {...item?.component?.sProps}
                handleItemClear={(id) => handleItemClear(id, item?.component?.sName)}
              />
            );
          } else if (item?.component.sType === "TEXTFIELD") {
            return (
              <TextField
                name={item?.component?.sName}
                onChange={e => {
                  takeInput(e, params.row.id);
                  e.stopPropagation();
                }}
                value={
                  rows && rows[params.row.id - 1] && rows[params.row.id - 1][item?.component?.sName]
                }
                {...item?.component?.sProps}
                onKeyDown={event => {
                  event.stopPropagation();
                }}
              />
            );
          } else if (item?.component.sType === "DATETIME") {
            return (
              <DateComponent
                handledatechange={e => handledatachange(e, params.row.id, item?.component?.sName)}
                data={item}
                datavalue={
                  rows && rows[params.row.id - 1] && rows[params.row.id - 1][item?.component.sName]
                }
                datemod={data?.component?.options?.mode}
                datatextvalue=""
                formaction={formAction}
                {...item?.component?.sProps}
              />
            );
          } else if (item.component.sType === "CHECKBOX") {
            return (
              <CheckBoxComponent
                data={item}
                onChange={e => takeInput(e, params.row.id)}
                datacheckvalue={
                  rows && rows[params.row.id - 1] && rows[params.row.id - 1][item?.component.sName]
                }
                datemod={item?.component?.options?.mode}
                formactions={formAction}
                {...item?.component?.sProps}
              />
            );
          } else if (item?.component.sType === "SELECT") {
            return (
              <Grid item {...data?.grid_props}>
                <SelectMainComponent
                  setSelectAndAutocompleteSname={setSelectAndAutocompleteSname}
                  onChange={summaryHandler("summ_tax")}
                  onChildSelect={handleSelectChange()}
                  data={data}
                  selectTax={selectTax}
                  summaryId={"summ_tax"}
                  {...data?.component?.sProps}
                  taxUrl={item.sRoute}
                  handleClickOpen={handleClickOpen}
                />
              </Grid>
            );
          } else {
            return;
          }
        }
      });
    });
  const [isTextSelected, setIsTextSelected] = useState(false);
  const handleSelectionChange = event => {
    const { selectionStart, selectionEnd } = event.target;

    setIsTextSelected(selectionStart !== selectionEnd);
  };

  const handleSelectionBlur = event => {
    setIsTextSelected(false);
  };
  data?.component?.options?.mode === "FREEFORM" &&
    data?.child?.forEach(item => {

      if (!isFreeFormColumnVisible(item, textValue)) {
        return;
      }

      const handleSelectionChange = event => {
        const { selectionStart, selectionEnd } = event.target;
        setIsTextSelected(selectionStart !== selectionEnd);
      };
      const handleSelectionBlur = event => {
        setIsTextSelected(false);
      };
      const handleFocus = event => {
        const { target, key } = event;
        const { value } = target;
        // Move cursor to the end
        if (!isTextSelected) {
          target.setSelectionRange(value.length, value.length);
        }
      };

      const handleNumerChange = (e, id) => {
        if (isTextSelected) {
          // alert(e.target.value[0])
          e.target.value =
            item?.component.iDecimalPlaces == 2
              ? "0.0" + e.target.value[e.target.value.length - 1]
              : e.target.value;
          setIsTextSelected(false);
        }
        FreeFormInput(e, id, "number", item?.component.iDecimalPlaces);
        //   takeInput(e, id, "CURRENCY", data?.inputType?.component.iDecimalPlaces);
      };

      function getKeyByValue(obj, value) {
        for (let key in obj) {
          if (obj[key] === value) {
            return value;
          }
        }
        return null;
      }

      function replaceSInventoryCode(uri, obj1, obj2) {
        let match = uri.match(/{(.*?)}/);
        let placeholder = match[1];
        let changedkey = getKeyByValue(obj2, placeholder);
        let changedData = obj1?.[changedkey];
        let newUri = uri?.replace(`{${placeholder}}`, changedData);
        return newUri;
      }

      function replacePlaceholders(uri, data) {
        if (uri) {
          const placeholderRegex = /{([^}]+)}/g;
          const replacedUri = uri?.replace(placeholderRegex, (match, placeholder) => {
            if (data.hasOwnProperty(placeholder)) {
              return data[placeholder];
            } else {
              return match;
            }
          });
          return replacedUri;
        }
      }

      /*eslint-enable no-undef*/
      // item?.inputtable?.bHidden == 0 &&
      columns.push({
         field: item?.inputtable?.sDisplayField || item?.component?.sDisplayField || item?.component?.sName,
          headerName: item.inputtable.sHeader,
          width: item.inputtable.iWidth,
          // editable: item?.inputtable?.bEditable,
          sortable: false,
          renderCell: params => {
            if (item?.component.sType === "VARVALUE") {
              const updatedParamsRow = {
                ...textValue,
                ...params.row
              };

              data?.child?.forEach(fieldConfig => {
                const componentName = fieldConfig?.component?.sName;
                const columnId = fieldConfig?.inputtable?.sColumnID;

                if (!componentName || !columnId) return;

                const rowValue = params.row?.[componentName] ?? params.row?.[columnId];

                if (rowValue !== undefined && rowValue !== null) {
                  updatedParamsRow[componentName] = rowValue;
                  updatedParamsRow[columnId] = rowValue;
                }
              });

              return (
                <Grid item {...item?.grid_props}>
                  <VarValue data={item} textValue={updatedParamsRow} />
                </Grid>
              );
            }
            if (item?.component.sType === "VARTEXT") {
              const styleFormatData = format?.data?.records?.find(
                item1 => item1?.sFieldName == item?.component?.sName 
                
              );
              const Icons = MUIICon[styleFormatData?.sStatusIcon];
              const parsedData = styleFormatData ? JSON.parse(styleFormatData?.sFieldFormat) : {};
              return (
                <>
                  {/* {JSON.stringify(format?.data?.records)} */}
                  <div
                    style={{ width: "100%" }}
                    id={
                      item?.component?.sName + "-" + item.inputtable.sColumnID + "-" + params.row.id
                    }
                  >
                    {/* {params.row.id - 1} */}
                    {/* {JSON.stringify(freeForm[0][item.component.sName])} */}
                    {/* {item?.inputtable?.bHidden == 0 ? ( */}
                      <Typography {...parsedData}>
                        {styleFormatData?.sStatusIcon && <Icons />}
                        {freeForm[params.row.id - 1]?.[item.component.sName]}
                      </Typography>
                    {/* ) : null} */}
                  </div>
                </>
              );
            }

            if (item?.component?.sType === "QUANTITY") {
            return (
              <QuantityCell
                item={item}
                params={params}
                freeForm={freeForm}
                setFreeformdata={setFreeformdata}
                freeFormTabbleEditArrays={freeFormTabbleEditArrays}
                mainFormData={mainFormData}
                allFeildForDoucmentSelect={allFeildForDoucmentSelect}
                token={token}
                isDisabledTable={isDisabledTable}
                serverAddress={serverAddress}
                handlePointChange1={handlePointChange1}
                getErrorDetails={getErrorDetails}
                freeFormError={freeFormError}
                handleFocus={handleFocus}
                handleSelectionBlur={handleSelectionBlur}
                handleSelectionChange={handleSelectionChange}
                handleNumerChange={handleNumerChange}
                replaceSInventoryCode={replaceSInventoryCode}
                replacePlaceholders={replacePlaceholders}
              />
            );
          }
            if (item?.component.sType === "VARNUMBER") {
              return (<>
              {/* {freeForm[params.row.id - 1]?.[item.component.sName]} */}
              <VARNUMBER data={item} value=  {freeForm[params.row.id - 1]?.[item.component.sName]}/>
              </>)
            }
            if (
              item?.component.sType === "NUMBER" ||
              item?.component.sType === "AMOUNT"
            ) {
              // console.log(isDisabledTable == false ? editable : isDisabledTable,'kkkki');
              const rawValue = freeForm?.[params.row.id - 1]?.[item.component.sName];

              return (
                <>
                  {item?.inputtable?.bVisible == "true" ? (
                    <>
                      {/* {item?.component?.sAdornPosition} */}
                      <div
                        style={{ width: "100%" }}
                        id={
                          item?.component?.sName +
                          "-" +
                          item.inputtable.sColumnID +
                          "-" +
                          params.row.id
                        }
                      >
                        <FixedDecimalTextField
                          component={item?.component}
                          id={`${item?.component?.sName}-${params.row.id}`}
                          name={item?.component?.sName}
                          onValueChange={value =>
                            FreeFormInput(
                              {
                                target: {
                                  name: item?.component?.sName,
                                  value
                                }
                              },
                              params.row.id,
                              "canonical-number"
                            )
                          }
                          disabled={isDisabledTable == false ? ((item?.inputtable?.bEditable == 1 || item?.inputtable?.bEditable == 3) ? false : true) : isDisabledTable}
                          value={rawValue}
                          {...item?.component?.sProps}
                          {...item?.component?.options?.others1}
                          error={
                            getErrorDetails(freeFormError, params.row.id)[item?.component?.sName]
                          }
                          placeholder={
                            getErrorDetails(freeFormError, params.row.id)[item?.component?.sName]
                              ? getErrorDetails(freeFormError, params.row.id)[item?.component?.sName]
                              : item?.component?.sPlaceHolder
                          }
                          helperText={
                            getErrorDetails(freeFormError, params.row.id)[item?.component?.sName] ||
                            item?.component?.sHelper
                          }
                          label={item?.component?.sLabel}
                          InputProps={
                            item?.component?.sAdornPosition?.toLowerCase() === "start"
                              ? {
                                  startAdornment: (
                                    <>
                                      {item?.component?.sAdornPosition &&
                                        item?.component?.sAdornType.toLowerCase() === "icon" && (
                                          <InputAdornment
                                            position={item?.component?.sAdornPosition}
                                          >
                                            <Icon iconName={item?.component?.sIcon} />
                                          </InputAdornment>
                                        )}
                                      {item?.component?.sAdornPosition &&
                                        item?.component?.sAdornType.toLowerCase() === "text" && (
                                          <InputAdornment
                                            position={item?.component?.sAdornPosition}
                                          >
                                            {item?.component?.sIcon}
                                          </InputAdornment>
                                        )}
                                    </>
                                  )
                                }
                              : {
                                  endAdornment: (
                                    <>
                                      {item?.component?.sAdornPosition &&
                                        item?.component?.sAdornType.toLowerCase() === "icon" && (
                                          <InputAdornment
                                            position={item?.component?.sAdornPosition}
                                          >
                                            <Icon iconName={item?.component?.sIcon} />
                                          </InputAdornment>
                                        )}
                                      {item?.component?.sAdornPosition &&
                                        item?.component?.sAdornType.toLowerCase() === "text" && (
                                          <InputAdornment
                                            position={item?.component?.sAdornPosition}
                                          >
                                            {item?.component?.sIcon}
                                          </InputAdornment>
                                        )}
                                    </>
                                  )
                                }
                          }
                        />
                      </div>
                    </>
                  ) : null}
                </>
              );
            }
            if (item?.component.sType === "AUTOCOMPLETE") {
              return item?.inputtable?.bVisible == "true" ? (
                <>
                  {/* {JSON.stringify(typeof item?.inputtable?.bVisible.toLowerCase())} */}

                  <div
                    style={{ width: "100%" }}
                    id={
                      item?.component?.sName + "-" + item.inputtable.sColumnID + "-" + params.row.id
                    }
                  >
                    <AutoComplete
                      rowScoped
                      resetSignal={globalReloadTriggred}
                      formcallback={(e, data, itemObj) =>
                        FreeFormCallBack(
                          e,
                          params?.row.id,
                          item?.component?.sName,
                          itemObj,
                          item.sMapping,
                          item
                        )
                      }
                      data={item}
                      errors={getErrorDetails(freeFormError, params.row.id)[item?.component?.sName] || ((uniqueErrors?.filter((field) => field.id == params.row.id))?.length > 0 ? uniqueErrors?.[0]?.helperText : null)}
                      textValue1={freeForm[params.row.id - 1]}
                      placeholder={item?.component?.sPlaceHolder}
                      rowsdataFree={
                        freeForm &&
                        freeForm[params.row.id - 1] &&
                        freeForm[params.row.id - 1][item?.component?.sName]
                      }
                      Automod={data?.component?.options?.mode}
                      formaction={formAction}
                      isDisabledTable={isDisabledTable == false ? ((item?.inputtable?.bEditable == 1 || item?.inputtable?.bEditable == 3) ? false : true) : isDisabledTable}
                      isSubmited={isSubmited}
                      {...item?.component?.sProps}
                      emptyHelperText=""
                      handleItemClear={(id) => handleItemClear(id, item?.component?.sName)}
                    />
                  </div>
                </>
              ) : null;
            } else if (item?.component.sType === "TEXTFIELD") {
              return item?.inputtable?.bVisible == "true" ? (
                <div
                  style={{ width: "100%" }}
                  id={
                    item?.component?.sName + "-" + item.inputtable.sColumnID + "-" + params.row.id
                  }
                >
                  <TextField
                    placeholder={item?.component?.sPlaceHolder}
                    name={item?.component?.sName}
                    helperText={
                      getErrorDetails(freeFormError, params.row.id)[item?.component?.sName] ||
                      item?.component?.sHelper
                    }
                    label={item?.component?.sLabel}
                    disabled={isDisabledTable == false ? ((item?.inputtable?.bEditable == 1 || item?.inputtable?.bEditable == 3) ? false : true) : isDisabledTable}
                    error={getErrorDetails(freeFormError, params.row.id)[item?.component?.sName]}
                    onChange={e => {
                      FreeFormInput(e, params.row.id);
                      e.stopPropagation();
                    }}
                    value={
                      freeForm &&
                      freeForm[params.row.id - 1] &&
                      freeForm[params.row.id - 1][item.component.sName]
                    }
                    id={item?.component?.sName + "-" + params.row.id}
                    onKeyDown={event => {
                      event.stopPropagation();
                    }}
                    InputProps={
                      item?.component?.sAdornPosition?.toLowerCase() === "start"
                        ? {
                            startAdornment: (
                              <>
                                {item?.component?.sAdornPosition &&
                                  item?.component?.sAdornType.toLowerCase() === "icon" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      <Icon iconName={item?.component?.sIcon} />
                                    </InputAdornment>
                                  )}
                                {item?.component?.sAdornPosition &&
                                  item?.component?.sAdornType.toLowerCase() === "text" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      {item?.component?.sIcon}
                                    </InputAdornment>
                                  )}
                              </>
                            )
                          }
                        : {
                            endAdornment: (
                              <>
                                {item?.component?.sAdornPosition &&
                                  item?.component?.sAdornType.toLowerCase() === "icon" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      <Icon iconName={item?.component?.sIcon} />
                                    </InputAdornment>
                                  )}
                                {item?.component?.sAdornPosition &&
                                  item?.component?.sAdornType.toLowerCase() === "text" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      {item?.component?.sIcon}
                                    </InputAdornment>
                                  )}
                              </>
                            )
                          }
                    }
                    {...item?.component?.sProps}
                  />
                </div>
              ) : null;
            } else if (item?.component.sType === "DATETIME") {
              return item?.inputtable?.bVisible == "true" ? (
                <div
                  style={{ width: "100%" }}
                  id={
                    item?.component?.sName + "-" + item.inputtable.sColumnID + "-" + params.row.id
                  }
                >
                  <DateComponent
                    disabled={isDisabledTable == false ? ((item?.inputtable?.bEditable == 1 || item?.inputtable?.bEditable == 3) ? false : true) : isDisabledTable}
                    handledatechange={e =>
                      handledatachange(e, params.row.id, item?.component?.sName)
                    }
                    data={item}
                    placeholder={item?.component?.sPlaceHolder}
                    datavalue={
                      freeForm &&
                      freeForm[params.row.id - 1] &&
                      freeForm[params.row.id - 1][item?.component.sName]
                    }
                    datemod={data?.component?.options?.mode}
                    datatextvalue=""
                    formaction={formAction}
                    {...item?.component?.sProps}
                  />
                </div>
              ) : null;
            } else if (item?.component.sType === "CHECKBOX") {
              return item?.inputtable?.bVisible == "true" ? (
                <div
                  style={{ width: "100%" }}
                  id={
                    item?.component?.sName + "-" + item.inputtable.sColumnID + "-" + params.row.id
                  }
                >
                  <CheckBoxComponent
                    data={item}
                    handleCheckbox={e => handledatachange(e, params.row.id, item?.component?.sName)}
                    datacheckvalue={
                      freeForm &&
                      freeForm[params.row.id - 1] &&
                      freeForm[params.row.id - 1][item?.component.sName]
                    }
                    datemod={data?.component?.options?.mode}
                    formactions={formAction}
                    {...item?.component?.sProps}
                  />
                </div>
              ) : null;
            } else if (item?.component.sType === "SWITCH") {
              let freeFormEditIndex = 0;
              if(freeFormTabbleEditArrays && freeFormTabbleEditArrays?.length > 0){
                const actualIndex = freeFormTabbleEditArrays.findIndex((arrItem) => arrItem?.sInputTableName == data?.component?.sName);
                if(actualIndex != -1){
                  freeFormEditIndex = actualIndex;
                }
              }
              return <RenderSwitchComponent 
                        id={params?.row?.id}
                        data={item} 
                        formData={mainFormData} 
                        toggleSwitchState={(name, value) => handledatachange(value, params?.row?.id, name)} 
                        freeFormTabbleEditMainrecord={freeFormTabbleEditArrays?.[freeFormEditIndex]?.tabledetails[params?.row?.id - 1]}
                      />
            } else if (item?.component.sType === "SELECT") {
              const handleCustomChange = (e, params, itemObj) => {
                let mapfeild = {};

                if (item?.sMapping && Object.keys(item?.sMapping).length > 0) {
                  const keys = Object.keys(item?.sMapping);
                  const values = Object.values(item?.sMapping);

                  for (let i = 0; i < keys.length; i++) {
                    const obj = {
                      ["name" + [i + 1]]: values[i],
                      ["value" + [i + 1]]: itemObj[keys[i]]
                    };
                    mapfeild = { ...mapfeild, ...obj };
                  }
                }
                // e.target ={...mapfeild}
                // const customEvent = {
                //   target: {
                //     ...e.target,
                //     ...mapfeild
                //   }
                // };
                // alert(JSON.stringify(customEvent))
                handledatachange(e, params.row.id, item?.component?.sName, mapfeild);
              };

              return item?.inputtable?.bVisible == "true" ? (
                <div
                  style={{ width: "100%" }}
                  id={
                    item?.component?.sName + "-" + item.inputtable.sColumnID + "-" + params.row.id
                  }
                >
                  <Grid item {...data?.grid_props}>
                    {/* {JSON.stringify(item?.sMapping)} */}
                    {/* <FormControl {...item?.component?.options?.others1}> */}
                    <SelectMainComponent
                      isDisabledTable={isDisabledTable == false ? ((item?.inputtable?.bEditable == 1 || item?.inputtable?.bEditable == 3) ? false : true) : isDisabledTable}
                      textValue={
                        freeForm && freeForm[params.row.id - 1] && freeForm[params.row.id - 1]
                      }
                      handledatasend={(e, obj) => handleCustomChange(e, params, obj)}
                      taxUrlFree={item?.data?.sDataSource}
                      sColumnID={item?.component?.sName}
                      errors={
                        getErrorDetails(freeFormError, params.row.id)?.[item?.component?.sName]
                      }
                      data={item}
                      {...item?.component?.sProps}
                      {...item?.component?.options?.others1}
                      datemod={data?.component?.options?.mode}
                      formaction={formAction}
                      selectEdit={
                        freeForm &&
                        freeForm[params.row.id - 1] &&
                        freeForm[params.row.id - 1][item?.component?.sName]
                      }
                      isSubmited={isSubmited}
                      handleClickOpen={handleClickOpen2}
                      setSelectAndAutocompleteSname={setSelectAndAutocompleteSname}
                    />
                    {/* </FormControl> */}
                  </Grid>
                </div>
              ) : null;
            } else {
              return;
            }
          }
        });
    });

  data?.fixcolumns?.forEach((item, ind) => {
    switch (item.sColumnID) {
      case "col_column1":
        (item?.bVisible == "true" || item?.bVisible == "!false") &&
          columns.push({
            field: item.sColumnID,
            headerName: item.sHeader,
            width: item.iWidth,
            // editable: item.bEditable,
            type: item.sType,
            sortable: true,
            renderCell: params => {
              const rowIndex = freeForm.findIndex(row => row.id === params.row.id);
              const rawValue = freeForm?.[rowIndex]?.[item.sColumnID];

              const val =
                rawValue !== ""
                  ? handlePointChange1(
                      rawValue?.toString(),
                      item?.inputType?.component?.iDecimalPlaces
                    )
                  : "";

              function findIndexById(id) {
                return freeForm.findIndex(item => item.id === id);
              }

              const handleNumerChange = (e, id) => {
                if (isTextSelected) {
                  // alert(e.target.value[0])
                  e.target.value =
                    item?.inputType?.component.iDecimalPlaces == 2
                      ? "0.0" + e.target.value[e.target.value.length - 1]
                      : e.target.value;
                  setIsTextSelected(false);
                }
                FreeFormInput(e, id, "number", item?.inputType?.component.iDecimalPlaces);
                //   takeInput(e, id, "CURRENCY", data?.inputType?.component.iDecimalPlaces);
              };
              return (
                <>

                  {/* {item?.inputType?.component?.sName} */}
                  {/* {params.row.id}----
{JSON.stringifsy(freeForm[findIndexById(params.row.id)]?.[item.sColumnID])} */}
                  <TextField
                    id={`${item?.inputType?.component?.sName}-${params.row.id}`}
                    name={item.sColumnID}
                    inputProps={{ style: { textAlign: item?.inputType?.component?.sJustify } }}
                    onChange={e => {
                      handleNumerChange(e, params.row.id);
                    }}
                    disabled={isDisabledTable == false ? ((item?.bEditable == 1 || item?.bEditable == 3) ? false : true) : isDisabledTable}
                    value={
                      freeForm[findIndexById(params.row.id)]?.[item.sColumnID] == ""
                        ? freeForm[findIndexById(params.row.id)]?.[item.sColumnID]
                        : val
                    }
                    {...item?.inputType?.component?.sProps}
                    {...item?.inputType?.component?.options?.others1}
                    onKeyDown={handleFocus}
                    onFocus={handleFocus}
                    onBlur={handleSelectionBlur}
                    onSelect={handleSelectionChange}
                    placeholder={item?.inputType?.component?.sPlaceHolder}
                    helperText={item?.inputType?.component?.sHelper}
                    label={item?.inputType?.component?.sLabel}
                    InputProps={
                      item?.inputType?.component?.sAdornPosition?.toLowerCase() === "start"
                        ? {
                            startAdornment: (
                              <>
                                {item?.inputType?.component?.sAdornPosition &&
                                  item?.inputType?.component?.sAdornType.toLowerCase() ===
                                    "icon" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      <Icon iconName={item?.inputType?.component?.sIcon} />
                                    </InputAdornment>
                                  )}
                                {item?.component?.sAdornPosition &&
                                  item?.component?.sAdornType.toLowerCase() === "text" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      {item?.inputType?.component?.sIcon}
                                    </InputAdornment>
                                  )}
                              </>
                            )
                          }
                        : {
                            endAdornment: (
                              <>
                                {item?.inputType?.component?.sAdornPosition &&
                                  item?.inputType?.component?.sAdornType.toLowerCase() ===
                                    "icon" && (
                                    <InputAdornment
                                      position={item?.inputType?.component?.sAdornPosition}
                                    >
                                      <Icon iconName={item?.inputType?.component?.sIcon} />
                                    </InputAdornment>
                                  )}
                                {item?.inputType?.component?.sAdornPosition &&
                                  item?.inputType?.component?.sAdornType.toLowerCase() ===
                                    "text" && (
                                    <InputAdornment
                                      position={item?.inputType?.component?.sAdornPosition}
                                    >
                                      {item?.inputType?.component?.sIcon}
                                    </InputAdornment>
                                  )}
                              </>
                            )
                          }
                    }
                  />
                </>
              );
            }
          });
        break;
      case "col_column2":
        (item?.bVisible == "true" || item?.bVisible == "!false") &&
          columns.push({
            field: item.sColumnID,
            headerName: item.sHeader,
            width: item.iWidth,
            // editable: item.bEditable,
            type: item.sType,
            sortable: true,
            renderCell: params => {
              const rowIndex = freeForm.findIndex(row => row.id === params.row.id);
              const rawValue = freeForm?.[rowIndex]?.[item.sColumnID];

              const val =
                rawValue !== ""
                  ? handlePointChange1(
                      rawValue?.toString(),
                      item?.inputType?.component?.iDecimalPlaces
                    )
                  : "";

              return (
                <>
                  {/* {item?.inputType?.component?.sName} */}

                  <TextField
                    id={`${item?.inputType?.component?.sName}-${params.row.id}`}
                    name={item.sColumnID}
                    inputProps={{ style: { textAlign: item?.inputType?.component?.sJustify } }}
                    onChange={e => {
                      FreeFormInput(
                        e,
                        params.row.id,
                        "number",
                        item?.inputType?.component.iDecimalPlaces
                      );
                    }}
                    disabled={isDisabledTable == false ? ((item?.bEditable == 1 || item?.bEditable == 3) ? false : true) : isDisabledTable}
                    value={
                      freeForm[params.row.id - 1]?.[item.sColumnID] == ""
                        ? freeForm[params.row.id - 1]?.[item.sColumnID]
                        : val
                    }
                    {...item?.inputType?.component?.sProps}
                    {...item?.inputType?.component?.options?.others1}
                    onKeyDown={handleFocus}
                    onFocus={handleFocus}
                    placeholder={item?.inputType?.component?.sPlaceHolder}
                    helperText={item?.inputType?.component?.sHelper}
                    label={item?.inputType?.component?.sLabel}
                    InputProps={
                      item?.inputType?.component?.sAdornPosition?.toLowerCase() === "start"
                        ? {
                            startAdornment: (
                              <>
                                {item?.inputType?.component?.sAdornPosition &&
                                  item?.inputType?.component?.sAdornType.toLowerCase() ===
                                    "icon" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      <Icon iconName={item?.inputType?.component?.sIcon} />
                                    </InputAdornment>
                                  )}
                                {item?.component?.sAdornPosition &&
                                  item?.component?.sAdornType.toLowerCase() === "text" && (
                                    <InputAdornment position={item?.component?.sAdornPosition}>
                                      {item?.inputType?.component?.sIcon}
                                    </InputAdornment>
                                  )}
                              </>
                            )
                          }
                        : {
                            endAdornment: (
                              <>
                                {item?.inputType?.component?.sAdornPosition &&
                                  item?.inputType?.component?.sAdornType.toLowerCase() ===
                                    "icon" && (
                                    <InputAdornment
                                      position={item?.inputType?.component?.sAdornPosition}
                                    >
                                      <Icon iconName={item?.inputType?.component?.sIcon} />
                                    </InputAdornment>
                                  )}
                                {item?.inputType?.component?.sAdornPosition &&
                                  item?.inputType?.component?.sAdornType.toLowerCase() ===
                                    "text" && (
                                    <InputAdornment
                                      position={item?.inputType?.component?.sAdornPosition}
                                    >
                                      {item?.inputType?.component?.sIcon}
                                    </InputAdornment>
                                  )}
                              </>
                            )
                          }
                    }
                  />
                </>
              );
            }
          });
        break;
      default:
        item?.bHidden == 0 &&
          columns.push({
            field: item.sColumnID,
            headerName: item.sHeader,
            width: item.iWidth,
            editable: item.bEditable,
            type: item.sType,
            sortable: true,
            renderCell: params => (
              <>{InputTableDefaultAllComponent(item)}</>
              // <TextField
              //   name={item.sColumnID}
              //   onChange={e => takeInput(e, params.row.id)}
              //   variant="outlined"
              //   size="small"
              // />
            )
          });
        break;
    }
  });

  data?.component?.options?.mode === "DEFAULT" &&
    columns.push({
      field: "",
      headerName: " ",
      width: 80,
      sortable: false,
      disableColumnMenu: true,
      renderCell: params => {
        const handleDelete = () => {
          const newRows = rows?.filter(row => row.id !== params.row.id);
          setRows(newRows);
        };
        if (params.row.id === 1) {
          return (
            <>
              <IconButton disabled aria-label="delete">
                <RemoveCircleOutlineIcon />
              </IconButton>
              <IconButton onClick={e => handleAddRow(e)} aria-label="delete">
                <AddCircleOutlineSharpIcon />
              </IconButton>
            </>
          );
        }
        return (
          <>
            <IconButton onClick={handleDelete} aria-label="delete">
              <RemoveCircleOutlineIcon />
            </IconButton>
            <IconButton onClick={e => handleAddRow(e)} aria-label="delete">
              <AddCircleOutlineSharpIcon />
            </IconButton>
          </>
        );
      }
    });

  if (
    data?.component?.options?.enableRowDelete ||
    data?.component?.options?.enableRowClone ||
    data?.component?.options?.enableRowAdd
  ) {
    if (data?.component?.options?.mode === "FREEFORM") {
      columns.push({
        field: "actions",

        headerName: "Actions",
        width: 150,
        sortable: false,
        disableColumnMenu: true,
        renderCell: params => {
          const handleDelete1 = id => {
            const newRows = freeForm?.filter(row => row.id !== id);
            newRows?.forEach((field, index) => {
              field.id = index + 1;
            })
            setFreeformdata(newRows);
            // alert(JSON.stringify(newRows));
            if (freeForm.length == 1) {
              const filteredComponents = filterComponentsRecursive(mainFormData.details);
              const tableData = getDataByType("INPUTTABLE", filteredComponents);

              const existingIndex = tableData?.filter(
                item => item.sInputTableName === data?.component?.sName
              );

              // if (existingIndex[0]?.tabledetails && existingIndex[0]?.tabledetails.length >= 1 ) {
              //   setFreeformdata([{ id: 1,...existingIndex[0]?.tabledetails[0]}]);
              // }
              // delete existingIndex[0]?.tabledetails[0].id

              const newRow = {
                id: freeForm.length + 1,
                ...existingIndex[0]?.tabledetails[0],
                ...fixedColumnFeilds
              };

              const updData = [...newRows, newRow];
              updData.forEach((item, index) => {
                item.id = index + 1;
              });

              setFreeformdata(updData);
            }
          };

          if (params.row.id === 1) {
            return (
              <>
                {data?.component?.options?.enableRowAdd && (
                  <IconButton
                    id={data.component.sName + "-add-" + params.row.id}
                    onClick={e => handleAddRow1(e)}
                    aria-label="add"
                  >
                    <AddCircleOutlineSharpIcon />
                  </IconButton>
                )}
                {data?.component?.options?.enableRowClone && (
                  <IconButton
                    onClick={e => handleCloneData(freeForm, params.row.id)}
                    aria-label="clone"
                    id={data.component.sName + "-clone-" + params.row.id}
                  >
                    <MoveDownIcon />
                  </IconButton>
                )}
                {data?.component?.options?.enableRowDelete && (
                  <IconButton
                    id={data.component.sName + "-delete-" + params.row.id}
                    onClick={() => handleDelete1(params.row.id)}
                    aria-label="delete"
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                )}
              </>
            );
          } else {
            return (
              <>
                {data?.component?.options?.enableRowAdd && (
                  <IconButton
                    id={data.component.sName + "-add-" + params.row.id}
                    onClick={e => handleAddRow1(e)}
                    aria-label="add"
                  >
                    <AddCircleOutlineSharpIcon />
                  </IconButton>
                )}
                {data?.component?.options?.enableRowClone && (
                  <IconButton
                    id={data.component.sName + "-clone-" + params.row.id}
                    onClick={e => handleCloneData(freeForm, params.row.id)}
                    aria-label="clone"
                  >
                    <MoveDownIcon />
                  </IconButton>
                )}
                {data?.component?.options?.enableRowDelete && (
                  <IconButton
                    id={data.component.sName + "-delete-" + params.row.id}
                    onClick={() => handleDelete1(params.row.id)}
                    aria-label="delete"
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                )}
              </>
            );
          }
        }
      });
    }
  }

  const options = [
    { key: "1x", value: 1 },
    { key: "5x", value: 5 },
    { key: "10x", value: 10 },
    { key: "15x", value: 15 },
    { key: "20x", value: 20 }
  ];

  function moveItemToZerothIndex(arr, field, col_item) {
    const index = arr.findIndex(item => item[field] === col_item);
    if (index > -1) {
      const [removed] = arr.splice(index, 1);
      arr.unshift(removed);
    }
    return arr;
  }

  // Example usage:

  moveItemToZerothIndex(columns, "field", "col_item");
  /*eslint-disable no-undef*/
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  /*eslint-enable no-undef*/
  const handleClick2 = event => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl1(null);
  };
  const open1 = Boolean(anchorEl1);
  const id = open1 ? "simple-popover" : undefined;

  function transformData(data, allFields, mappingFields, ind = 2) {
    return data.map((item, index) => {
      let transformedItem = { id: index + 1 };

      // Copy all fields and values from allFields
      Object.entries(allFields).forEach(([key, value]) => {
        transformedItem[key] = value;
      });

      // Change the values of fields in mappingFields
      mappingFields.forEach(field => {
        if (item[field]) {
          transformedItem[field] = item[field];
        }
      });

      return transformedItem;
    });
  }

  function heraferidatauseEffect(matchfeild, allfeild, receivdata) {
    const arr = [];
    for (let i = 0; i < receivdata.length; i++) {

      let allFeildKeys = Object.keys(allfeild);
      let allFeildValues = Object.values(allfeild);
      let row = { id: i + 1 };
      allFeildKeys.map((elm, ind) => {
        return (row[allFeildValues[ind]] = receivdata[i][allFeildValues[ind]] || (receivdata[i][allFeildValues[ind]] === 0 ? 0 : ""));
      });

      let matchKey = Object.keys(matchfeild);
      let rowKey = Object.keys(receivdata[i]);
      const matchedElements = {};
      matchKey.forEach(item => {
        if (rowKey.includes(item)) {
          matchedElements[matchfeild[item]] = receivdata[i][item];
        }
      });
      arr.push(row);
      //  alert(JSON.stringify(arr));
    }

    return arr;
  }

  function heraferidata(matchfeild, allfeild, receivdata) {
    const arr = [];
    for (let i = 0; i < receivdata.length; i++) {
      let row = {};
      let matchKey = Object.keys(matchfeild);
      let rowKey = Object.keys(receivdata[i]);
      const matchedElements = {};
      matchKey.forEach(item => {
        if (rowKey.includes(item)) {
          matchedElements[matchfeild[item]] = receivdata[i][item];
          matchedElements[item] = receivdata[i][item];
        }
      });

      const replacedObject = replaceKeys(i, matchedElements, allfeild);
      arr.push(replacedObject);
    }
    return arr;
  }

  function replaceKeys(i, obj, allfeild) {
    const newObj = { id: i + 1 };
    for (const key in obj) {
      if (allfeild[key]) {
        newObj[allfeild[key]] = obj[key];
      } else {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  }

  // Example usage
  async function hanldeGetDataFromElipsis(uri, type, mappingFeilds) {
  try {
    if (!uri) return;

    setLoading(true);

    const response = await axios.get(serverAddress + uri, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const records = response?.data?.data?.records || [];

    const filteredComponents = filterComponentsRecursive(mainFormData.details);
    const tableData = getDataByType("INPUTTABLE", filteredComponents);

    const existingTable = tableData?.find(
      item => item.sInputTableName === data?.component?.sName
    );

    const matchedFields = {
      ...(existingTable?.tabledetails?.[0] || {})
    };

    const newFreeData = heraferidata(
      { ...matchedFields, ...mappingFeilds },
      allfeildsNames,
      records
    );

    const searchFieldConfig = getSearchFieldConfig();

    const searchFieldName =
      searchFieldConfig?.component?.sSearchField ||
      searchFieldConfig?.inputtable?.sSearchField;

    const newData = newFreeData.map((row, index) => {
      const sourceRecord = records?.[index] || {};
      const searchText = buildSearchText(sourceRecord, searchFieldConfig);

      const newItem = {
        ...matchedFields,
        ...row,
        id: index + 1
      };

      if (searchFieldName && searchText?.trim()) {
        newItem[searchFieldName] = searchText;
      }

      return newItem;
    });

   setFreeformdata(prev =>
      JSON.stringify(prev || []) === JSON.stringify(newData || [])
        ? prev
        : newData
    );

  } catch (error) {
    console.log(JSON.stringify(error));
  } finally {
    setLoading(false);
  }
}

  const [selectedLoadfromFile, setSelectedLoadfromFile] = useState();
  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  // alert(JSON.stringify(freeFormValidation))
  const validateFreeFormField = (value, validation = {}) => {
  const rawValue = value ?? "";
  const stringValue = String(rawValue).trim();
  const isEmpty = stringValue === "";

  const isRequired =
    Number(validation?.bRequired) === 1 ||
    validation?.bRequired === true;

  const errorMessage = validation?.sErrorMessage || "Invalid value";

  if (!isEmpty && validation?.sRegex) {
    const regex = new RegExp(validation.sRegex);

    if (!regex.test(stringValue)) {
      return errorMessage;
    }
  }

  if (isRequired && isEmpty) {
    return errorMessage;
  }

  if (!isRequired && isEmpty) {
    return "";
  }

  const minLen = Number(validation?.iMinLen || 0);
  const maxLen = Number(validation?.iMaxLen || 0);

  if (minLen > 0 && stringValue.length < minLen) {
    return errorMessage;
  }

  if (maxLen > 0 && stringValue.length > maxLen) {
    return errorMessage;
  }

  const minValue = Number(validation?.iMinValue || 0);
  const maxValue = Number(validation?.iMaxValue || 0);
  const numericValue = Number(stringValue.replace(/,/g, ""));

  const isNumericValidation =
    validation?.sType === "NUMERIC" ||
    validation?.sType === "NUMBER" ||
    minValue > 0 ||
    maxValue > 0;

  if (isNumericValidation && !Number.isNaN(numericValue)) {
    if (minValue > 0 && numericValue < minValue) {
      return errorMessage;
    }

    if (maxValue > 0 && numericValue > maxValue) {
      return errorMessage;
    }
  }

  return "";
};

  const validateData = () => {
    const visibleValidationFields = new Set(
      data?.child
        ?.filter(item => isFreeFormColumnVisible(item, textValue))
        .map(item => item?.component?.sName)
        .filter(Boolean) || []
    );
    const activeValidation = Object.fromEntries(
      Object.entries(freeFormValidation).filter(([fieldName]) => {
        const childField = data?.child?.some(
          item => item?.component?.sName === fieldName
        );
        return !childField || visibleValidationFields.has(fieldName);
      })
    );

    const returnData = freeForm.map(rowData => {
      const normalizedData = { ...rowData };
      for (const key in activeValidation) {
        if (normalizedData[key] === undefined || normalizedData[key] === null) {
          normalizedData[key] = "";
        }
      }
      const textValue = normalizedData;
      const errors = {};

      for (const key in activeValidation) {
        const err = validateFreeFormField(textValue[key], activeValidation[key]);

        if (err) {
          errors[key] = err;
        }
      }

      const index = freeFormError.findIndex(row => row?.id == textValue?.id);

      if (index != -1) {
        const newData = JSON.parse(JSON.stringify(freeFormError));
        newData[index] = { ...errors, id: textValue?.id };
        setfreeFormError(newData);
      } else {
        setfreeFormError(preState => {
          const index = preState.findIndex(row => row?.id == textValue?.id);
          if (index == -1) {
            return [...preState, { ...errors, id: textValue?.id }];
          } else {
            return preState;
          }
        });
      }

      return isEmpty(errors);
    });

    return returnData.includes(false);
  };

  function replacePlaceholders2(uri, data) {
    const regex = /{([^}]+)}/g;
    const replacedUri = uri.replace(regex, (match, key) => {
      return key in data ? data[key] : match;
    });
    return replacedUri;
  }

  const dataAwareField = data?.data?.sDataAware?.replace(/[{}]/g, "");
  const dataAwareValue = dataAwareField ? textValue?.[dataAwareField] : undefined;

  useEffect(() => {
    const loadData = async () => {
      if (data?.data?.bCascade && dataAwareValue !== undefined) {
        await hanldeGetDataFromElipsis(
          replacePlaceholders2(data?.data?.sDataSource, textValue),
          "useEffect",
          data?.data?.sMapping
        );
      }

      if (data?.component?.defaultLoad?.bEnabled === true) {
        await hanldeGetDataFromElipsis(
          data?.component?.defaultLoad?.sDataSource,
          "useEffect",
          data?.component?.defaultLoad?.sMapping
        );
      }
    };

    loadData();
  }, [
    data?.data?.bCascade,
    data?.data?.sDataSource,
    data?.data?.sMapping,
    dataAwareValue,
    data?.component?.defaultLoad?.bEnabled,
    data?.component?.defaultLoad?.sDataSource,
    data?.component?.defaultLoad?.sMapping
  ]);

  //================================================================================================================================
  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("lg");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMaxWidthChange = event => {
    setMaxWidth(
      // @ts-expect-error autofill of arbitrary value is not handled.
      event.target.value
    );
  };

  const handleFullWidthChange = event => {
    setFullWidth(event.target.checked);
  };

  function filterDataByMapping(data, mapping) {
    const allowedFields = Object.values(mapping);
  
    return data.map(item => {
      const filteredItem = {};
      allowedFields.forEach(field => {
        if (item[field] !== undefined) {
          filteredItem[field] = item[field];
        }
      });
      if(item["id"]){
        filteredItem["id"] = item["id"];
      }
      return filteredItem;
    });
  }

  const [BulkLoadData, setBulkLoadData] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleBulkLoad = type => {
    setLoading(true);
    const filteredComponents = filterComponentsRecursive(mainFormData.details);
    const tableData = getDataByType("INPUTTABLE", filteredComponents);
    const existingIndex = tableData?.filter(
      item => item?.sInputTableName === data?.component?.sName
    );
    const newRow = {
      ...existingIndex[0]?.tabledetails[0]
    };
    const matchedFields = newRow;
    const mappingFields = [...Object.keys(data?.component?.[type]?.sMapping)];

    let transformedData = transformData(BulkLoadData, matchedFields, mappingFields, 0);
    transformedData.forEach((transformedField) => {
      for (const [key, value] of Object.entries(data?.component?.[type]?.sMapping)) {
        if (typeof transformedField[key] === 'number' && !isNaN(transformedField[key])) {
          transformedField[key] = transformedField[key].toFixed(2);
      } 
        transformedField[allfeildsNames[value]] = transformedField[key];
      }
    })
    const mappedFilteredData = filterDataByMapping(transformedData, allfeildsNames);
    const searchFieldConfig = getSearchFieldConfig();

    const searchFieldName =
      searchFieldConfig?.component?.sSearchField ||
      searchFieldConfig?.inputtable?.sSearchField;

    mappedFilteredData.forEach((transformedField, index) => {
      const searchText = buildSearchText(BulkLoadData[index], searchFieldConfig);

      if (searchFieldName && searchText?.trim()) {
        transformedField[searchFieldName] = searchText;
      }
    });
    // setFreeformdata((pre)=>([...pre,...transformedData]));
    setFreeformdata(mappedFilteredData);
    // setFreeformdata((pre)=>([...pre,...transformedData]));
    // setFreeformdata([...freeForm, newRow]);
    handleClose();
  };

  useEffect(() => {
    if (freeForm.length > 0) {
      const checkRenderComplete = () => {
        requestAnimationFrame(() => {
          setLoading(false);
        });
      };
      checkRenderComplete();
    }
  }, [freeForm]);

  //================================================================================================================================
  const [actionType, setActionType] = useState("");
  const [fileInputKey] = useState(Date.now());
  const [csvFile, setCsvFile] = useState();
  const [csvFileToggle, setCSVFileToggle] = useState(false);
  const [csvFileBackup, setCsvFileBackup] = useState();


  function removeBlankObjects(data) {
    return data.filter(obj => Object.values(obj).some(val => val !== undefined && val !== ""));
  }
  const fileChange = (e) => {
    setCSVFileToggle(false);
    const file = e.target.files[0];
    if (file) {
      processFile(file);
    }
  };
 
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      processFile(file);
    }
  };
 
  const processFile = (file) => {
    const reader = new FileReader();
 
    reader.onload = (e) => {
      const data1 = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data1, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const headers = jsonData[0];
      const dataArray = jsonData.slice(1);
      const result = dataArray.map(row => {
        const obj = {};
        headers.forEach((header, index) => {
          obj[header] = row[index];
        });
        return obj;
      });
      setCsvFile(removeBlankObjects(result));
      setCsvFileBackup(removeBlankObjects(result));
 
      const arry = data?.component?.loadFromFile?.sMapping.split(", ");
      data?.child?.forEach((item) => {
        if (arry.includes(item?.inputtable?.sColumnID)) {
          setSelectedLoadfromFile((pre) => ({
            ...pre,
            [item?.inputtable?.sHeader]: Object.keys(removeBlankObjects(result)[0]).find(
              (items) => items === item?.inputtable?.sHeader
            ),
          }));
        }
      });
    };
    reader.onerror = error => {
      console.error(error);
    };
    reader.readAsArrayBuffer(file);
  }; 
  csvFile?.forEach((item, ind) => (item.id = ind + 1));
  const clearColumns = data => {
    // let allfeilds = Object.keys(allfeildsNames);
    const newVal = freeForm.map(item => {
      const newItem = { ...item }; // Create a copy of the item object
      // allfeilds.forEach(field => {
      //   console.log("ebjgebkjrenr",newItem, allfeildsNames, data?.sMapping, field === data?.sMapping)
      //   if (newItem.hasOwnProperty(field) && field === data?.sMapping) {
      //     newItem[field] = ""; // Clear the value of the field
      //   }
      // });
      Object.entries(allfeildsNames).forEach(([key, value]) => {
        if (newItem.hasOwnProperty(value) && key === data?.sMapping) {
          newItem[value] = 0;
        }
      });
      return newItem;
    });
    setFreeformdata(newVal);
  };

  function replacePlaceholder(uri, textValue) {
    // Find the key within {} in the URI
    let keyStartIndex = uri.indexOf("{") + 1;
    let keyEndIndex = uri.indexOf("}", keyStartIndex);
    let key = uri.substring(keyStartIndex, keyEndIndex);

    // Replace the placeholder in the URI with the corresponding value from textValue
    let updatedUri = uri.replace(`{${key}}`, textValue[key]);

    return updatedUri;
  }

  function maptoRow() {
  const filteredComponents = filterComponentsRecursive(mainFormData?.details);
  const tableData = getDataByType("INPUTTABLE", filteredComponents);

  const existingTable = tableData?.find(
    item => item?.sInputTableName === data?.component?.sName
  );

  const matchedFields = {
    ...(existingTable?.tabledetails?.[0] || {})
  };

  const searchFieldConfig = getSearchFieldConfig();

  const searchFieldName =
    searchFieldConfig?.component?.sSearchField ||
    searchFieldConfig?.inputtable?.sSearchField;

  const uniqueFieldConfig = getUniqueFieldConfig();
  const uniqueFieldName = uniqueFieldConfig?.component?.sName;

  const uniqueValueField =
    uniqueFieldConfig?.data?.sValueField ||
    uniqueFieldName;

  const searchDisplayFields =
    searchFieldConfig?.component?.sSearchDisplayFields ||
    searchFieldConfig?.inputtable?.sSearchDisplayFields;

  const displayFields = Array.isArray(searchDisplayFields)
    ? searchDisplayFields
    : searchDisplayFields
        ? searchDisplayFields.split(",").map(field => field.trim())
        : [];

  const findAutocompleteRecord = value => {
    if (!value || !Array.isArray(globalFreeFormAutoValueData)) {
      return null;
    }

    return globalFreeFormAutoValueData.find(record => {
      if (uniqueValueField && record?.[uniqueValueField] == value) {
        return true;
      }

      return displayFields.some(field => record?.[field] == value);
    });
  };

  const transformedData = (csvFile || []).map((csvRow, index) => {
    const transformedItem = {
      ...matchedFields,
      id: index + 1
    };

    Object.entries(selectedLoadfromFile || {}).forEach(([columnId, fileColumnName]) => {
      const targetFieldName =
      allfeildsNames[columnId] ||
      data?.child?.find(
        field =>
          field?.inputtable?.sHeader === columnId ||
          field?.inputtable?.sColumnID === columnId
      )?.component?.sName;
      const csvValue = csvRow?.[fileColumnName];

      if (!targetFieldName) return;

      if (uniqueFieldName && targetFieldName === uniqueFieldName) {
        const matchedRecord = findAutocompleteRecord(csvValue);
        const uniqueValue = matchedRecord?.[uniqueValueField] || csvValue;

        transformedItem[targetFieldName] = uniqueValue;

        const searchText = buildSearchText(matchedRecord, searchFieldConfig);

        if (searchFieldName && searchText?.trim()) {
          transformedItem[searchFieldName] = searchText;
        }
      } else {
        transformedItem[targetFieldName] = csvValue;
      }
    });

    return transformedItem;
  });

  setFreeformdata(transformedData);
  handleClose();
}

  const [firstTotal, setFirstTotal] = useState("0.00");
  const [secondTotal, setSecondtTotal] = useState("0.00");
  const isFixColumnVisible = columnId => {
  const column = data?.fixcolumns?.find(item => item?.sColumnID === columnId);
  return column?.bVisible === "true" || column?.bVisible === "!false";
};

const showFirstTotal = isFixColumnVisible("col_column1");
const showSecondTotal = isFixColumnVisible("col_column2");

  useEffect(() => {
    // alert(JSON.stringify(freeForm))
    let value1 = 0; // Initialize value1 to avoid undefined behavior
    let value2 = 0; // Initialize value1 to avoid undefined behavior
    for (let i = 0; i < freeForm.length; i++) {
      value1 += +freeForm[i]["col_column1"]?.toString()?.replace(/,/g, "") || 0;
      value2 += +freeForm[i]["col_column2"]?.toString()?.replace(/,/g, "") || 0;
    }
    setFirstTotal(value1);
    setSecondtTotal(value2);
    // alert(`${value1}--${value2}`);
    setFreeFromTotals(value1 + value2);
    // alert(JSON.stringify(freeForm))
    setfreeFormValidateFunction(() => validateData);
    return () => {
      // setAllfeildsNames( {});
      // setAllfeildsNames1( {});
      // setAllfeildsWithsType( {});
      setfreeFormValidateFunction(false);
    };
  }, [freeForm]);
function replaceKeysSendData(data1, data2 = {}) {
  return data1.map(row => {
    const newItem = { ...row };

    for (const key in data2) {
      if (key in newItem && data2[key]) {
        newItem[data2[key]] = newItem[key];
        delete newItem[key];
      }
    }

    return newItem;
  });
}
  function replaceKeys4(first, second) {
    let newObject = {};
    for (let key in first) {
      if (second.hasOwnProperty(key)) {
        newObject[second[key]] = first[key];
      } else {
        newObject[key] = first[key];
      }
    }
    return newObject;
  }
  function replaceValuesInArray(result, third, forth) {
    if (third) {
      let newArray = third?.map((_, index) => {
        // Create a new item or copy an existing item from the forth array
        let newItem = index < forth.length ? { ...forth[index] } : {};

        // Set the id property starting from 1
        newItem.id = index + 1;

        // Iterate over each key in the result object
        for (let key in result) {
          // If the key from the result object exists in the current forth object or it is a new item
          if (newItem.hasOwnProperty(key) || !forth[index]) {
            // Get the corresponding key from the result object
            let thirdKey = result[key];
            // Replace the value in the forth object with the value from the third object
            newItem[key] = third[index][thirdKey];
          }
        }

        return newItem;
      });

      return newArray;
    }
  }

  useEffect(() => {
    let result = replaceKeys4(documentSelectmappingData, allFeildForDoucmentSelect);

    const usingTable = documentSelectTableData.filter(
      item => item?.mappingTableName == data.component.sName
    );

    let tableData = usingTable?.tabledetails;

    if (usingTable && usingTable?.length > 0) {
      const mappedData = replaceValuesInArray(
        replaceKeys4(documentSelectmappingData, allFeildForDoucmentSelect),
        usingTable[0]?.tabledetails,
        freeForm
      );
      setFreeformdata(mappedData);
    }
  }, [documentSelectTableData, documentSelectmappingData]);

  // Handle eventSelectTableData from payment form (when customer is selected)
  useEffect(() => {
    const tableDetails = eventSelectTableData?.data?.tablerecords?.[0]?.tabledetails;

    if (!tableDetails || tableDetails.length === 0) {
      return;
    }

    const labelToApiFieldMap = {
      "invoice date": ["dtDate", "dtInvoiceDate", "InvoiceDate", "col_invoice_date"],
      "invoice number": ["sDocNumber", "sInvoiceNumber", "InvoiceNumber", "DocNumber", "col_invoice_number"],
      "invoice no": ["sDocNumber", "sInvoiceNumber", "InvoiceNumber", "DocNumber", "col_invoice_number"],
      "ref doc": ["sReferenceDoc", "sRefDoc", "ReferenceDoc", "RefDoc", "col_ref_doc"],
      "reference doc": ["sReferenceDoc", "sRefDoc", "ReferenceDoc", "RefDoc", "col_ref_doc"],
      "ref number": ["sReferenceNumber", "sRefNumber", "ReferenceNumber", "RefNumber", "col_ref_number"],
      "reference number": ["sReferenceNumber", "sRefNumber", "ReferenceNumber", "RefNumber", "col_ref_number"],
      "due date": ["dtDueDate", "DueDate", "col_due_date"],
      "balance": ["dAmount", "AmountIn", "dBalance", "Balance", "dBalanceDue", "BalanceDue", "col_balance_due"],
      "balance due": ["dAmount", "AmountIn", "dBalance", "Balance", "dBalanceDue", "BalanceDue", "col_balance_due"],
      "amount": ["dAmount", "AmountIn", "Amount", "col_amount"],
      "payment": ["dPayment", "Payment", "AmountPaid", "col_payment"]
    };

    const mappedRows = tableDetails.map((record, index) => {
      const rowItem = { id: index + 1 };

      data?.fixcolumns?.forEach((colItem) => {
        const colId = colItem?.sColumnID;
        const colLabel = (colItem?.sLabel || "").toLowerCase().trim();
        const colName = colItem?.inputType?.component?.sName;

        for (const [labelKey, apiFields] of Object.entries(labelToApiFieldMap)) {
          if (colLabel.includes(labelKey)) {
            for (const apiField of apiFields) {
              if (record[apiField] !== undefined && record[apiField] !== null) {
                rowItem[colName || colId] = record[apiField];
                break;
              }
            }
            break;
          }
        }

        if (rowItem[colName || colId] === undefined) {
          if (colName && record[colName] !== undefined) {
            rowItem[colName] = record[colName];
          } else if (record[colId] !== undefined) {
            rowItem[colId] = record[colId];
          }
        }
      });

      for (const [colId, sName] of Object.entries(allFeildForDoucmentSelect)) {
        if (record[sName] !== undefined) {
          rowItem[sName] = record[sName];
        }
        if (record[colId] !== undefined) {
          rowItem[sName] = record[colId];
        }
      }

      Object.keys(record).forEach((key) => {
        if (rowItem[key] === undefined) {
          rowItem[key] = record[key];
        }
      });

      return rowItem;
    });

    if (mappedRows.length > 0) {
      setFreeformdata(mappedRows);
    }
  }, [eventSelectTableData, eventSelectTableMapping, allFeildForDoucmentSelect]);

function openLoadFromDocument(data){
  setOpenDocumentSelect(true)
}
function mapDataKeys(data, mapToData) {
  const keysToMatch = Object.keys(mapToData);

  return data.map(item => {
    let newItem = {};

    keysToMatch.forEach(oldKey => {
      if (item.hasOwnProperty(oldKey)) {
        const newKey = mapToData[oldKey]; // Get the new key name from mapToData
        newItem[newKey] = item[oldKey]; // Assign the value to the new key in newItem
      }
    });

    return newItem;
  });
}

function replaceKeysWithmatchingKeys(data, feildsData) {
  return data.map(item => {
    let newItem = {};

    // Iterate over each key in the item
    Object.keys(item).forEach(key => {
      if (feildsData.hasOwnProperty(key) && key !== "col_column1" && key !== "col_column2") {
        // Replace key with the corresponding value from feildsData
        newItem[feildsData[key]] = item[key];
      } else {
        // Keep the key as is if it is "col_column1" or "col_column2"
        newItem[key] = item[key];
      }
    });

    return newItem;
  });
}
useEffect(()=>{
  if (multiDocumentSelectDataForTable.length > 0) {
    let data1 = mapDataKeys(multiDocumentSelectDataForTable,data?.component.loadfromdocument.sMapping)
    let data2 = replaceKeysWithmatchingKeys(data1,allfeildsNames1)

    for (let i = 0; i < data2.length; i++) {
      data2[i].id = i+1
      
    }
    // alert(JSON.stringify(data2))
    setFreeformdata(data2)
  }

},[multiDocumentSelectDataForTable])
// multiDocumentSelectDataForTable,setmultiDocumentSelectDataForTable

  function updateRowPosition(initialIndex, newIndex, rows) {
    return new Promise((resolve) => {
      setTimeout(
        () => {
          const rowsClone = [...rows];
          const row = rowsClone.splice(initialIndex, 1)[0];
          rowsClone.splice(newIndex, 0, row);
          resolve(rowsClone);
        },
        Math.random() * 500 + 100,
      );
    });
  }

  const handleRowOrderChange = async (params) => {
    const newRows = await updateRowPosition(
      params.oldIndex,
      params.targetIndex,
      rows,
    );

    setRows(newRows);
  };

  return (
    <ComponentLoadingBoundary
      loading={loading}
      label={`Loading ${data?.component?.sName}`}
      minHeight={150}
      size={30}
    >
      {/* {JSON.stringify(data)} */}

      {/* id={data.component.sName} */}
      {/* 
    {JSON.stringify( documentSelectTableData[0]?.mappingTableName )} */}
      {/* 
    {JSON.stringify(replaceKeys4(documentSelectmappingData, allFeildForDoucmentSelect) )} */}
      {/* <button onClick={()=>}>click</button> */}
      {/* {JSON.stringify(replaceValuesInArray(replaceKeys4(documentSelectmappingData, allFeildForDoucmentSelect),  documentSelectTableData[0]?.tabledetails
    , freeForm))}
      {JSON.stringify(freeForm)} */}
      {/* {JSON.stringify(documentSelectTableData[0]?.tabledetails)} */}

      {/* {data?.component?.sName} */}
      <>
        {/* {data.component?.options?.mode === "DEFAULT" && (
          <InputTableDefault
            data={data}
            formData={formData}
            defaultTableEditData={freeFormTabbleEditArrays}
            mainFormData={mainFormData}
            company={company}
            isSubmited={isSubmited}
            format={format}
            formAction={formAction}
            textValue={textValue}
            tabledata={tabledata}
            tablesummaryfields={tablesummaryfields}
            setdefaultTableValidateFunction={setdefaultTableValidateFunction}
          />
        )} */}

        {/* {data?.component?.options?.mode === "DEBITCREDIT" && (
          <DebitCredit
            freeFormTabbleEditArrays={freeFormTabbleEditArrays}
            setdifferenceDebitCredit={setdifferenceDebitCredit}
            tablefreeformfield={tablefreeformfield}
            setdebitCreditTableData={setdebitCreditTableData}
            freeFormTabbleArrays={freeFormTabbleArrays}
            setFreeFormTabbleArrays={setFreeFormTabbleArrays}
            isSubmited={isSubmited}
            company={company}
            format={format}
            mainFormData={mainFormData}
            formAction={formAction}
            data={data}
            baseURL={baseURL}
            formdata={formdata}
            setdebitCreditValidateFunction={setdebitCreditValidateFunction}
          />
        )} */}

        {/* {JSON.stringify(freeForm)}
        {data.component.sName} */}
        {data?.component?.options?.submode !== "HIDDEN" && (
          <>
            <Box style={{ display: "flex", justifyContent: "end" }}>
              {data?.component?.options?.mode === "FREEFORM" &&
                JSON.stringify(data?.component?.menu?.bEnabled) == "true" && (
                  <>
                    <IconButton sx={{ cursor: "pointer" }} onClick={handleClick2}>
                      <Icon
                        aria-describedby={id}
                        iconName={data?.component?.menu?.sIcon}
                        sProps={data?.component?.menu?.sIconProps}
                        dataSProps={data?.component?.menu?.sIconProps}
                      />
                      <Typography 
                        id={`${data?.component?.sName}-actions`}
                        {...data?.component?.menu?.sLabelProps}
                      >
                        {data?.component?.menu?.sMenuCaption}
                      </Typography>
                    </IconButton>
                    <Popover
                      id={id}
                      open={open1}
                      anchorEl={anchorEl1}
                      onBlur={handleClose2}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center"
                      }}
                    >
                      <List>
                        {data?.component?.defaultLoad?.bEnabled === true && (
                          <ListItem>
                            <Typography
                              id={`${data?.component?.sName}-actions-1`}
                              onClick={() => {
                                const filteredComponents = filterComponentsRecursive(
                                  mainFormData.details
                                );
                                const tableData = getDataByType("INPUTTABLE", filteredComponents);
                                const existingIndex = tableData?.filter(
                                  item => item.sInputTableName === data?.component?.sName
                                );
                                const newRow = {
                                  id: 1,
                                  ...existingIndex[0]?.tabledetails[0]
                                };
                                setFreeformdata([newRow]);
                                handleClose2();
                              }}
                              className="cursor-pointer"
                            >
                              Reset Table
                            </Typography>
                          </ListItem>
                        )}
                        {data?.component?.clearValues?.bEnabled === true && (
                          <ListItem>
                            <Typography
                              id={`${data?.component?.sName}-actions-2`}
                              className="cursor-pointer"
                              onClick={() => {
                                clearColumns(data?.component?.clearValues);
                                handleClose2();
                              }}
                            >
                              {data?.component?.clearValues?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}
                        {data?.component?.resetTable?.bEnabled === true && (
                          <ListItem>
                            <Typography
                              id={`${data?.component?.sName}-actions-3`}
                              className="cursor-pointer"
                              onClick={(e) => {
                                setBulkLoadData([]);
                                setFreeformdata([]);
                                handleAddRow1(e, true);
                                handleClose2();
                              }}
                            >
                              {data?.component?.resetTable?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}
                        {data?.component?.defaultLoad?.bEnabled === true && (
                          <ListItem>
                            <Typography
                              id={`${data?.component?.sName}-actions-4`}
                              className="cursor-pointer"
                              onClick={() => {
                                hanldeGetDataFromElipsis(
                                  data?.component?.defaultLoad?.sDataSource,
                                  "btn",
                                  data?.component?.defaultLoad?.sMapping
                                );
                                handleClose2();
                              }}
                            >
                              {data?.component?.defaultLoad?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}
                        {data?.component?.bulkLoad?.bEnabled === true && (
                          <ListItem>
                            <Typography
                              id={`${data?.component?.sName}-actions-5`}
                              className="cursor-pointer"
                              onClick={() => {
                                handleClickOpen(), setActionType("bulkLoad");
                              }}
                            >
                              {data?.component?.bulkLoad?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}
                        {data?.component?.bulkLoad2?.bEnabled === true && (
                          <ListItem>
                            <Typography
                              id={`${data?.component?.sName}-actions-6`}
                              className="cursor-pointer"
                              onClick={() => {
                                handleClickOpen(), setActionType("bulkLoad2");
                              }}
                            >
                              {data?.component?.bulkLoad2?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}
                        {data?.component?.bulkLoad3?.bEnabled === true && (
                          <ListItem>
                            <Typography
                              id={`${data?.component?.sName}-actions-7`}
                              className="cursor-pointer"
                              onClick={() => {
                                handleClickOpen(), setActionType("bulkLoad3");
                              }}
                            >
                              {data?.component?.bulkLoad3?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}

                        {data?.component?.loadFromFile?.bEnabled === true && (
                          <ListItem className="cursor-pointer">
                            <Typography
                              id={`${data?.component?.sName}-actions-8`}
                              className="cursor-pointer"
                              onClick={() => {
                                handleClickOpen(); 
                                setActionType("loadFromFile");
                                setCSVFileToggle(true);
                              }}
                            >
                              {data?.component?.loadFromFile?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}

                        {/* //loadfromdocument */}
                        {data?.component?.loadfromdocument?.bEnabled === true && (
                          <ListItem className="cursor-pointer">
                            id={`${data?.component?.sName}-actions-9`}
                            <Typography
                              className="cursor-pointer"
                              onClick={() => {
                             openLoadFromDocument(data?.component?.loadfromdocument)
                              }}
                            >
                              {data?.component?.loadfromdocument?.sSubmenuCaption}
                            </Typography>
                          </ListItem>
                        )}
                      </List>
                    </Popover>
                  </>
                )}{" "}
            </Box>

            {data?.component?.options?.mode === "FREEFORM" && (
              <Box id={data.component.sName}>
                {(submitPayloadLoading) && (
                  <Spinner description='Saving...' />
                )}
                <div style={{
                  ...data?.component?.sParentContainerProps?.style,
                  filter: submitPayloadLoading ? 'blur(5px)' : 'none',
                }}>                
                  <DataGridPro
                    rows={freeForm}
                    slots={(data?.component?.slotProps && Object.keys(data?.component?.slotProps).length > 0) ? {
                      toolbar: GridToolbar,
                    } : {}}
                    slotProps={data?.component?.slotProps}
                    columns={columns}
                    // pagination={true}
                    disableColumnMenu={true}
                    hideFooter={false}
                    {...data.component?.sProps}
                    rowReordering
                    onRowOrderChange={handleRowOrderChange}
                  />
                </div>
              </Box>
            )}
            <Box sx={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
              {data.component?.options?.mode === "FREEFORM" &&
                data?.component?.options?.enableRowAdd && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      border: "1px solid #42a5f5",
                      height: "2%"
                    }}
                  >
                    <Button
                      startIcon={<AddCircleOutlinedIcon onClick={e => handleAddRow1(e)} />}
                      id={`${data?.component?.sName}-addrowbutton`}
                      sx={{
                        border: "none",
                        "&:hover": {
                          border: "none"
                        }
                      }}
                      variant="outlined"
                      onClick={e => handleAddRow1(e)}
                    >
                      Add Row
                    </Button>
                    <select
                      id={`${data?.component?.sName}-addrow`}
                      onChange={handleAddRow1}
                      style={{ border: "none", outline: "none" }}
                    >
                      <option></option>
                      {options.map((option, index) => {
                        return (
                          <option key={index} value={option?.value} id={`${data?.component?.sName}-addrow${option?.key}`}>
                            {option?.key}
                          </option>
                        );
                      })}
                    </select>
                  </Box>
                )}

              {/* {JSON.stringify(data?.component?.options?.submode.toLowerCase().includes('computation')) } */}
            {data?.component?.options?.submode?.toLowerCase()?.includes("computation") &&
              (showFirstTotal || showSecondTotal) && (
                <Box style={{ minWidth: "570px" }}>
                  <Grid container>
                    <Grid item xs={4}>
                      Total
                    </Grid>

                    {showFirstTotal && (
                      <Grid item xs={4} id={`${data?.component?.sName}-col_column1totals`}>
                        {handlePointChange1(parseFloat(firstTotal).toFixed(2), 2)}
                      </Grid>
                    )}

                    {showSecondTotal && (
                      <Grid item xs={4} id={`${data?.component?.sName}-col_column2totals`}>
                        {handlePointChange1(parseFloat(secondTotal).toFixed(2), 2)}
                      </Grid>
                    )}
                  </Grid>
                </Box>
              )}
              {/* {console.log(data?.summaryfields?.sSummaryDetails, 7788)} */}
              {/* {JSON.stringify(freeForm)} */}
              {/* {console.log(rows, "emptyfreeform")} */}

              {data?.options?.mode === "FREEFORM" && (
                <Box {...data.summaryfields?.sContainerProps}>
                  {data?.summaryfields?.sSummaryDetails?.map(item => {
                    return (
                      <Box
                        key={item.sSummaryID}
                        py={1}
                        sx={{ display: "flex", align: "center", gap: 10 }}
                      >
                        <Typography>{item.sLabel}</Typography>
                        {item.sFieldInput === "TEXTFIELD" && item.sSummaryID === "summ_handling" ? (
                          // <TextField onChange={summaryHandler("summ_handling")} />
                          <>
                            <p>hello</p>
                          </>
                        ) : item.sFieldInput === "TEXTFIELD" &&
                          item.sSummaryID === "summ_shipping" ? (
                          <>
                            <TextField onChange={summaryHandler(item?.sAction, "summ_shipping")} />
                            <p>hello</p>
                          </>
                        ) : item.sFieldInput === "TEXTFIELD" &&
                          item.sSummaryID === "summ_discount" ? (
                          <>
                            <TextField onChange={summaryHandler(item?.sAction, "summ_discount")} />
                            <p>hello</p>
                          </>
                        ) : item.sFieldInput === "none" && item.sSummaryID === "summ_subtotal" ? (
                          <Typography>{subtotal1}</Typography>
                        ) : item.sFieldInput === "none" && item.sSummaryID === "summ_grandtotal" ? (
                          <Typography>{grand_total === 0 ? subtotal1 : grand_total}</Typography>
                        ) : null}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          </>
        )}
      </>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={
          actionType === "bulkLoad" || actionType === "bulkLoad2" || actionType === "bulkLoad3"
            ? maxWidth
            : "sm"
        }
        open={open}
        //  onClose={handleClose}
      >
        <IconButton
          onClick={()=>{
            handleClose(false);
            if(csvFileBackup){
              setCsvFileBackup(csvFileBackup);
            }
          }}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          {" "}
          {actionType === "bulkLoad" || actionType === "bulkLoad2" || actionType === "bulkLoad3"
            ? data?.component?.[actionType]?.sSubmenuCaption
            : data?.component?.loadFromFile?.sSubmenuCaption}
        </DialogTitle>
        <DialogContent>
          {actionType === "bulkLoad" || actionType === "bulkLoad2" || actionType === "bulkLoad3" ? (
            <SelectAllTransferList
              setBulkLoadData={setBulkLoadData}
              freeForm={freeForm}
              data={data}
              sDisplayFormat={data?.component?.bulkLoad?.sDisplayFormat}
              token={token}
              uri={replacePlaceholder(data?.component?.[actionType]?.sDataSource, textValue)}
            />
          ) : (
            <>
              {(!csvFile || csvFileToggle) ? (
                <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                onDragOver={(e) => e.preventDefault()}
              >
                <Paper
                  style={{ cursor: "pointer" }}
                  onDrop={(e) => {
                    setCSVFileToggle(false);
                    e.preventDefault();
                    const file = e.dataTransfer.files[0];
                    if (file) {
                      fileChange({ target: { files: [file] } }); 
                    }
                  }}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <label htmlFor="fileInput">
                    <Box width={500} height={140}>
                      <Box p={2} display="flex" flexDirection="column" alignItems="center">
                        <CloudUploadIcon fontSize="large" />
                        <Typography variant="body1" gutterBottom>
                          Click to file
                        </Typography>
                        <input
                          type="file"
                          id="fileInput"
                          key={fileInputKey}
                          accept=".csv, .xlsx, .xls"
                          maxLength={"5mb"}
                          style={{ display: "none" }}
                          onChange={fileChange}
                        />
                        <Typography variant="body2" color="primary" component="span">
                          Select a file
                        </Typography>
                        <Typography variant="body2" className="pt-3" component="span">
                          (CSV file, max file size of 5MB)
                        </Typography>
                      </Box>
                    </Box>
                  </label>
                </Paper>
                {/* {data?.component?.loadFromFile?.sMapping} */}
              </Box>
              ) : (
                <>
                  {/* {JSON.stringify(removeBlankObjects(csvFile))} */}

                  {(() => {
                    const arry = data?.component?.loadFromFile?.sMapping.split(", ");
                    return (
                      <>
                        {data?.child?.map(item => {
                          if (arry.includes(item?.inputtable?.sColumnID)) {
                            return (
                              <Box sx={{ display: "flex", margin: "10px" }}>
                                <Box sx={{ width: "50%", alignSelf: "center" }}>
                                  {item?.inputtable?.sHeader}
                                </Box>
                                <Box sx={{ width: "50%" }}>
                                  <Select
                                    fullWidth={true}
                                    labelId="select-label"
                                    id="select"
                                    name={item.inputtable.sColumnID}
                                    onChange={e =>
                                      setSelectedLoadfromFile(pre => ({
                                        ...pre,
                                        [e.target.name]: e.target.value
                                      }))
                                    }
                                    size="small"
                                    defaultValue={ Object.keys(csvFile[0])?.find((items)=> items == item?.inputtable?.sHeader) ? Object.keys(csvFile[0]).find((items)=> items == item?.inputtable?.sHeader) : "Select"}
                                  >
                                    <MenuItem value={"Select"}>
                                          Select
                                    </MenuItem>
                                    {Object.keys(csvFile[0]).map((item, index) => (
                                      <MenuItem key={item} value={item}>
                                        {item}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Box>
                              </Box>
                            );
                          }
                        })}
                      </>
                    );
                  })()}
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="contained"
            disabled={BulkLoadData.length == 0 && selectedLoadfromFile == undefined}
            onClick={() => {
              setCSVFileToggle(false);
              if (selectedLoadfromFile != undefined) {
                maptoRow();
              } else {
                handleBulkLoad(actionType);
              }
            }}
            id="button-save"
          >
            Save
          </Button>
          <Button size="small" variant="contained" onClick={() => {
              setCSVFileToggle(false);
              handleClose();
              if(csvFileBackup){
                setCsvFile(csvFileBackup);
              }
            }
          } id="button-close">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </ComponentLoadingBoundary>
  );
};

export default TableComponent;
